import React, { useEffect, useState, forwardRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, Link } from "react-router-dom";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import { useForm, FormProvider, Controller } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { AES, enc } from "crypto-js";
import Select from 'react-select';
import Header from "../Header";
import Footer from "../Footer";
import { API_URL } from '../config';
import Tooltip from '../tooltip/Tooltip';
import $ from "jquery";
import Editor from 'react-simple-wysiwyg';
import axios from "axios";
import RecentItem from "../recentitem/rececentItem";
// import { decryptedAccessToken, encryptedAccessToken } from "../../Token";
import {
  Card,
  OverlayTrigger,
  Table,
} from "react-bootstrap";

import { FaPencilAlt, FaTrashAlt, FaPlus } from "react-icons/fa";
import { FaRegRegistered } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import Button from "react-bootstrap/Button";
import { IoIosHelpCircle } from "react-icons/io";
const NewAccounts = () => {
  const secret_key = "4d3a23fba54bbef1e14dd44ba9591612";
  const encryptedAccessToken = localStorage.getItem("access_token");
  const decryptedAccessToken = encryptedAccessToken
    ? AES.decrypt(encryptedAccessToken, secret_key).toString(enc.Utf8)
    : null;

  const navigate = useNavigate();
  const [company,setCompany]=useState([]);



  // date
  const [startDate, setStartDate] = useState(null);

  const reference_date = startDate ? `${startDate.getDate().toString().padStart(2, '0')}/${(startDate.getMonth() + 1).toString().padStart(2, '0')}/${startDate.getFullYear()}` : null;

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };


   const [kycdoc, setKycdoc] = useState(null);
   const ky_date_date = kycdoc ? `${kycdoc.getDate().toString().padStart(2, '0')}/${(kycdoc.getMonth() + 1).toString().padStart(2, '0')}/${kycdoc.getFullYear()}` : null;


  const handleStartDateKyc = (date) => {
    setKycdoc(date);
  };

  //  const kyc_date = kycdoc ? `${kycdoc.getDate().toString().padStart(2, '0')}/${(kycdoc.getMonth() + 1).toString().padStart(2, '0')}/${kycdoc.getFullYear()}` : null;


   // edit page
   const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Please Enter Full Company Name here
    </Tooltip>
  );
  const trader = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Trader
    </Tooltip>
  );
  const phone = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Phone numbers are a great way to call people on phones.  Phones are what we call our pocket computers even though we use them for games, selfies, and facebook.
    </Tooltip>
  );

const adminRole=localStorage.getItem('role')

  // dropdown
  const optionsCompany = company.map(item => ({
    value: item.company_name,
    label: item.company_name
  }));

  const [companydrop, setCompanydrop] = useState(null);

  const handleCompany = (companydrop) => {
    setCompanydrop(companydrop);
  };
  

  const [isFormsubmit, setFormsubmited] = useState(false);

  const [startDate1, setStartDate1] = useState(new Date());
  const birthDate=startDate1.toLocaleDateString("en-US", { year: 'numeric' })+"-"+(startDate1.toLocaleDateString("en-US", { month: '2-digit' }))+"-"+(startDate1.toLocaleDateString("en-US", { day: '2-digit' }))
 const CustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
   <input
     value={value}
     className="custom-input"
     onClick={onClick}
     name="birthdate"
     onChange={onChange}
     ref={ref}
   ></input>
 ));

 const [reference1, setReference1] = useState(new Date());
  const referenceDate=reference1.toLocaleDateString("en-US", { year: 'numeric' })+"-"+(reference1.toLocaleDateString("en-US", { month: '2-digit' }))+"-"+(reference1.toLocaleDateString("en-US", { day: '2-digit' }))
 const ReferenceInput = forwardRef(({ value, onClick, onChange }, ref) => (
   <input
     value={value}
     className="custom-input"
     onClick={onClick}
     name=""
     onChange={onChange}
     ref={ref}
   ></input>
 ));




useEffect(() => {

  fetchDataAccount();
}, [decryptedAccessToken]);

const fetchDataAccount = async () => {
  try {
    const response = await axios.get(`${API_URL}get/all/rwoodcompany`, {
      headers: { Authorization: `Bearer ${decryptedAccessToken}` },        }
    );
    const data = response.data.rwoodcompany;
    setCompany(data)
     console.log(data)
  } catch (error) {
    console.error(error);
  }
};

  const [account_name, setaccount_name] = useState('');
  const [documents, setDocuments] = useState([{ document_name: '', validity: '' }]);

  const handleDocumentChange = (index, field, value) => {
    const updatedDocuments = [...documents];
    updatedDocuments[index][field] = value;

    setDocuments(updatedDocuments);
  };

  const handleAddDocument = () => {
    setDocuments([...documents, { document_name: '', validity: '' }]);
  };

  const handleRemoveDocument = (index) => {
    const updatedDocuments = [...documents];
    updatedDocuments.splice(index, 1);
    setDocuments(updatedDocuments);
  };

  const location = useLocation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const {
    reset: reset2,
    register: register2,
    formState: { errors: errors2 },
    handleSubmit: handleSubmit2,
  } = useForm({
    mode: "onBlur",
  });
  const {
    reset: reset3,
    register: register3,
    formState: { errors: errors3 },
    handleSubmit: handleSubmit3,
  } = useForm({
    mode: "onBlur",
  });
  const {
    reset: reset4,
    register: register4,
    formState: { errors: errors4 },
    handleSubmit: handleSubmit4,
  } = useForm({
    mode: "onBlur",
  });
  const {
    reset: reset5,
    register: register5,
    formState: { errors: errors5 },
    handleSubmit: handleSubmit5,
  } = useForm({
    mode: "onBlur",
  });

  const { account_record } = location.state;
//  Recent Items


const [pendingMatter, setPendingMatter] = useState()
const [shippingAddress, setShippingAddress] = useState()
const [generalTerms, setGeneralTermn] = useState()
const [paymentTerms, setPaymentTerms] = useState()
const [nomination, setNomination] = useState()
const [berth, setBerth] = useState()
const [loadings, setLoadings] = useState()
function onChangePending(e) {
  setPendingMatter(e.target.value);
}
function onChangeNomination(e) {
  setNomination(e.target.value);
}
function onChangeBerth(e) {
  setBerth(e.target.value);
}
function onChangeLoadings(e) {
  setLoadings(e.target.value);
}

function onChangeShippingAddress(e) {
  setShippingAddress(e.target.value);
}
function onChangeGeneralTerm(e) {
  setGeneralTermn(e.target.value);
}
function onChangePaymentTerm(e) {
  setPaymentTerms(e.target.value);
}



  if (account_record === "Agent") {
    const onSubmit = (data) => {
      setFormsubmited(true)
      const responseData = {
        account_name: data.account_name,
        account_alias: data.account_alias,
        website: data.website,
        account_owner: data.account_owner,
        parent_account: data.parent_account,
        account_number: data.account_number,
        account_record_type: data.account_record_type,
        annual_revenue: parseInt(data.annual_revenue),
        no_of_employees: data.no_of_employees,
        port: data.port,
        origin: data.origin,
        remarks: data.remarks,
        product: data.product,
        general_terms: generalTerms,
        region: data.region,
        billing_street: pendingMatter,
        phone: data.phone,
        shipping_street: shippingAddress,
        billing_city: data.billing_city,
        billing_postal_code:data.billing_postal_code,
        shipping_postal_code: data.shipping_postal_code,
        shipping_city: data.shipping_city,
        shipping_state_or_province: data.shipping_state_or_province,
        shipping_country: data.shipping_country,
        billing_state_or_province: data.billing_state_or_province,
        billing_country: data.billing_country,
        fax: data.fax,
        KYC_docs: data.KYC_docs,
        KYC_doc_date: ky_date_date?ky_date_date:null,
        refrence_check_date:reference_date?reference_date:null,
        refrence_check: data.refrence_check,
        commitment: data.commitment,
        reliability: data.reliability,
        under_group: data.under_group,
        station_name: data.station_name,
        expansion_setup_or_buyer_status: data.expansion_setup_or_buyer_status,
        industry: data.industry,
        sector: data.sector,
        market_impression_rating: data.market_impression_rating,
        annual_coal_requirement_in_MT: data.annual_coal_requirement_in_MT,
        imported_volume_PA_in_MT: data.imported_volume_PA_in_MT,
        quantity_MT_monthly: data.quantity_MT_monthly,
        production_capacity: data.production_capacity,
        originiaze_import_breakup: data.originiaze_import_breakup,
        account_source: data.account_source,
        rating: data.rating,
        coal_spec_1_3800_GAR: data.coal_spec_1_3800_GAR,
        coal_spec_2_4200_GAR: data.coal_spec_2_4200_GAR,
        coal_spec_3_4700_GAR: data.coal_spec_3_4700_GAR,
        coal_spec_4_5000_GAR: data.coal_spec_4_5000_GAR,
        coal_spec_5_5500_GAR: data.coal_spec_5_5500_GAR,
        description: data.description,
        coal_spec_6: data.coal_spec_6,
        coal_spec_7: data.coal_spec_7,
        coal_spec_8: data.coal_spec_8,
        documents
      };
      console.log(JSON.stringify(responseData));
      const encryptedAccessToken = localStorage.getItem("access_token");
      const secret_key = "4d3a23fba54bbef1e14dd44ba9591612";
      if (encryptedAccessToken) {
        const decryptedAccessToken = AES.decrypt(
          encryptedAccessToken,
          secret_key
        ).toString(enc.Utf8);

        axios.post(`${API_URL}add/account`, responseData, {
          headers: {
            Authorization: `Bearer ${decryptedAccessToken}`,
            "Content-Type": "application/json",
          },
        })
          .then(response => {
            console.log(response);

            if (response.data.success === true) {
              document.getElementById('messageContainer').innerHTML = `
                  <div class="success-message">
                  ${response.data.message}
                  </div>
              `;

                window.scrollTo({
                  top: 0,
                  behavior: "smooth" // Optional: animated scrolling
              });


              navigate("/accounts/" + response.data.account_id);
          } else if (response.data.success === false) {

              document.getElementById('messageContainer').innerHTML = `
                  <div class="error-message">
                      ${response.data.message}
                  </div>
              `;

              // Scroll to the top of the page
              window.scrollTo({
                  top: 0,
                  behavior: "smooth" // Optional: animated scrolling
              });
          }
          })
          .catch(error => {
            // Handle errors
            console.error(error);
          });
      }
    };

    return (
      <>
        <Header />
        <div className="contactAccount  full-container">
          <div className="row">
        <div className="col-md-2 recent-item">
          <RecentItem/>
        </div>
        <div className="col-md-10 right-section">
        <div className="page-header" id="add-account">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Accounts </h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">
                  Dashboard / Account/ Add Agent
                </li>
              </ol>
            </div>
          </div>
          <Form onSubmit={handleSubmit(onSubmit)}>
          <div id="messageContainer"></div>
          <p className='edit-cancel'><input
      type="submit"
      className="account-save"
      value={isFormsubmit ? "Saving" : "Save"}
      disabled={isFormsubmit}
    /><Link to={'/accounts/account-list'}><input type="submit" className="account-save" value="Cancel" /></Link></p>
            <Row className="mb-3">
              <h4 className="heading">Account Information</h4>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Name"
                    className="error-validation"
                    name="account_name"
                    tabIndex="1" 
                    {...register("account_name", { required: true })}
                  />
                 { errors.account_name && <span>Error: You must enter a value </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Owner"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Owner"
                    name="account_owner"
                    value={adminRole}
                    tabIndex="9" 
                    className="owner-role"
                    {...register("account_owner", { required: false })}
                  />
                  {errors.account_owner && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Alias"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Alias"
                    name="account_alias"
                    tabIndex="2" 
                    {...register("account_alias", { required: false })}
                  />
                  {errors.account_alias && <span>Error: You must enter a value</span>}
                </FloatingLabel>
               
                <Tooltip text={<span>Please Enter Full Company Name here</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Number"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Account Number"
                    name="account_number"
                    tabIndex="10" 
                    {...register("account_number", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.website && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Website"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Website"
                    name="website"
                    tabIndex="3" 
                    {...register("website", { required: false })}
                  />
                  {errors.website && <span>Error: You must enter a value</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account record type"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account record type"
                    value={account_record}
                    tabIndex="11" 
                    name="account_record_type" className='record-type'
                    {...register("account_record_type", { required: false })}
                  />
                  {errors.account_record_type && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Trader"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Trader"
                    name="trader"
                    tabIndex="4" 
                    {...register("trader", { required: false })}
                  />
                  {errors.trader && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Trader</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
                
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Annual Revenue"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Annual Revenue"
                    name="annual_revenue"
                    tabIndex="12" 
                    {...register("annual_revenue", { required: false })}
                  />
                  {errors.annual_revenue && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Port"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Port"
                    name="port"
                    tabIndex="5" 
                    {...register("port", { required: false })}
                  />
                  {errors.port && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>


             <Form.Group as={Col} md="6">
              <FloatingLabel
                controlId="floatingInput"
                label="No of employees"
                className="mb-3"
              >
                <Form.Control
                  type="number"
                  placeholder="No of employees"
                  name="no_of_employees"
                  tabIndex="13" 
                  {...register("no_of_employees", {
                    valueAsNumber: true,
                    required: false,
                  })}
                />
                {errors.no_of_employees && <span>Required</span>}
              </FloatingLabel>
            </Form.Group>
            <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              {/* <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Annual revenue"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Annual revenue"
                    name="annual_revenue"
                    {...register("annual_revenue", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.annual_revenue && <span>Required</span>}
                </FloatingLabel>
              </Form.Group> */}

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Origin"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Origin"
                    name="origin"
                    tabIndex="6" 
                    {...register("origin", { required: false })}
                  />
                  {errors.origin && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              {/* <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="No of employees"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="No of employees"
                    name="no_of_employees"
                    {...register("no_of_employees", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.no_of_employees && <span>Required</span>}
                </FloatingLabel>
              </Form.Group> */}

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Product"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Product"
                    name="product"
                    tabIndex="7" 
                    {...register("product", { required: false })}
                  />
                  {errors.product && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Remarks"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Remarks"
                    name="remarks"
                    tabIndex="14" 
                    {...register("remarks", { required: false })}
                  />
                  {errors.remarks && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
            </Row>
            <Row className="mb-3">
              <h4 className="heading">Address Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Region"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Region"
                    name="region"
                    tabIndex="14" 
                    {...register("region", { required: false })}
                  />
                  {errors.region && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6" className='tooltips'>
                <FloatingLabel
                  controlId="floatingInput"
                  label="Phone"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Phone"
                    name="phone"
                    tabIndex="21"

                    {...register("phone", { required: false })}
                  />
                  {errors.phone && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Phone numbers are a great way to call people on phones. <br/> Phones are what we call our pocket computers <br/>even though we use them for games, selfies,<br/> and facebook.</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>

              <Form.Group as={Col} md="6" className="textarea-half b-t">
              <label>Billing Address</label>
              <Editor value={pendingMatter} onChange={onChangePending} tabIndex="15"/>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Fax"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="fax"
                    name="fax"
                    tabIndex="22"
                    {...register("fax", { required: false })}
                  />
                  {errors.fax && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing postal code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing postal code"
                    name="billing_postal_code"
                    tabIndex="16"
                    {...register("billing_postal_code", { required: false })}
                  />
                  {errors.billing_postal_code && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6" className="textarea-half b-t">
              <label>Shipping Address</label>
              <Editor value={shippingAddress} onChange={onChangeShippingAddress} tabIndex="23" />
              </Form.Group>
             

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing city"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing city"
                    name="billing_city"
                    tabIndex="17"
                    {...register("billing_city", { required: false })}
                  />
                  {errors.billing_city && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping postal code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping postal code"
                    name="shipping_postal_code"
                    tabIndex="24"
                    {...register("shipping_postal_code", { required: false })}
                  />
                  {errors.shipping_postal_code && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing state province"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing state province"
                    name="billing_state_or_province"
                    tabIndex="18"
                    {...register("billing_state_or_province", {
                      required: false,
                    })}
                  />
                  {errors.billing_state_or_province && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping city"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping city"
                    name="shipping_city"
                    tabIndex="25"
                    {...register("shipping_city", { required: false })}
                  />
                  {errors.shipping_city && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>


              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing country"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing country"
                    name="billing_country"
                    tabIndex="19"
                    {...register("billing_country", { required: false })}
                  />
                  {errors.billing_country && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping state province"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping state province"
                    name="shipping_state_or_province"
                    tabIndex="26"
                    {...register("shipping_state_or_province", {
                      required: false,
                    })}
                  />
                  {errors.shipping_state_or_province && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
            <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping country"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing country"
                    name="shipping_country"
                    tabIndex="27"
                    {...register("shipping_country", { required: false })}
                  />
                  {errors.shipping_country && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <h4 className="heading">KYC Documents</h4>
               {documents.map((document, index) => (
        <>

          <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Document Name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Document Name"
                    tabIndex="28"
                    defaultValue={document.name}
                    onChange={(e) => handleDocumentChange(index, 'document_name', e.target.value)}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Validity"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Validity"
                    tabIndex="29"
                    defaultValue={document.validity}
                    onChange={(e) => handleDocumentChange(index, 'validity', e.target.value)}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="1">
          {index > 0 && (
            <span id="links" onClick={() => handleRemoveDocument(index)}><FaTrashAlt/></span>
          )}
          </Form.Group>
        </>
      ))}
      <span id="links" onClick={handleAddDocument}>Add Document</span>
      {/* <button onClick={handleSubmit}>Create Account</button> */}
              </Row>
              <Row className="mb-3">
              <h4 className="heading">Rwood Reference</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="KYC docs"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="KYC docs"
                    name="KYC_docs"
                    tabIndex="30"
                    {...register("KYC_docs", { required: false })}
                  />
                  {errors.KYC_docs && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Commitment"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="commitment"
                    placeholder="Commitment"
                    tabIndex="34"
                    {...register("commitment", { required: false })}
                  >
                    <option value="">--None--</option><option value="Medium Term">Medium Term</option><option value="Short Term">Short Term</option><option value="Long Term">Long Term</option><option value="Promptly">Promptly</option>
                  </Form.Select>
                  {errors.commitment && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>




   <Form.Group as={Col} md="6">
        <FloatingLabel
          controlId="floatingInput"
          label="KYC Doc date"
          className="mb-3 datepick"


        >
           <DatePicker
        selected={kycdoc}
        onChange={handleStartDateKyc}
        dateFormat='dd/MM/yyyy'
        tabIndex="31"
        startDate={kycdoc} placeholderText="Select"
      />
        </FloatingLabel>
      </Form.Group>

      <Form.Group as={Col} md="6"  className="textarea-half">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Reliability"
                  className="mb-3"
                >
                  <Form.Control
                    as="textarea"
                    placeholder="Reliability"
                    name="reliability"
                    tabIndex="35"
                    {...register("reliability", { required: false })}
                  />
                  {errors.reliability && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Refrence check"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Refrence check"
                    name="refrence_check"
                    tabIndex="32"
                    {...register("refrence_check", { required: false })}
                  />
                  {errors.refrence_check && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6">
        <FloatingLabel
          controlId="floatingInput"
          label="Refrence Check Date"
          className="mb-3 datepick"


        >
           <DatePicker
        selected={startDate}
        onChange={handleStartDateChange}
        selectsStart
        tabIndex="33"
        dateFormat='dd/MM/yyyy'
        startDate={startDate} placeholderText="Select"

      />
        </FloatingLabel>
      </Form.Group>
        <Form.Group as={Col} md="6"></Form.Group>
            </Row>
            <Row className="mb-3">
              <h4 className="heading">Industry Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Parent account"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Parent account"
                    name="parent_account"
                    tabIndex="36"
                    {...register("parent_account", { required: false })}
                  />
                  {errors.parent_account && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="annual coal requirement in  MT"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="annual coal requirement in  MT"
                    name="annual_coal_requirement_in_MT"
                    tabIndex="41"
                    {...register("annual_coal_requirement_in_MT", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.annual_coal_requirement_in_MT && (
                    <span>Required</span>
                  )}
                </FloatingLabel>
                <Tooltip text={<span>in MT</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Under group"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Under group"
                    name="under_group"
                    tabIndex="37"
                    {...register("under_group", { required: false })}
                  />
                  {errors.under_group && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Imported volume PA in MT"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Imported volume PA in MT"
                    name="imported_volume_PA_in_MT"
                    tabIndex="42"
                    {...register("imported_volume_PA_in_MT", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.imported_volume_PA_in_MT && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>{" "}
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Station name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Station name"
                    name="station_name"
                    tabIndex="37"
                    {...register("station_name", { required: false })}
                  />
                  {errors.station_name && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>{" "}
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Quantity MT monthly"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Quantity MT monthly"
                    name="quantity_MT_monthly"
                    tabIndex="43"
                    {...register("quantity_MT_monthly", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.quantity_MT_monthly && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Expansion setup or buyer status"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="expansion_setup_or_buyer_status"
                    placeholder="Expansion setup or buyer status"
                    tabIndex="37"
                    {...register("expansion_setup_or_buyer_status", {
                      required: false,
                    })}
                  >
                    <option value="">Select</option>
                    <option value="Under Construction">
                      Under Construction
                    </option>
                    <option value="Operated">Operated</option>
                    <option value="Permitted">Permitted</option>
                  </Form.Select>
                  {errors.expansion_setup_or_buyer_status && (
                    <span>Required </span>
                  )}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Production /Capacity Utilisation (Unit %)"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Production /Capacity Utilisation (Unit %)"
                    name="production_capacity"
                    tabIndex="44"
                    {...register("production_capacity", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.production_capacity && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
<Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Originiaze Import Break up (TPO/ %)	"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Originiaze Import Break up (TPO/ %)	"
                    name="originiaze_import_breakup"
                    tabIndex="45"
                    {...register("originiaze_import_breakup", {
                      required: false,
                    })}
                  />
                  {errors.originiaze_import_breakup && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
                            <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Industry"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="industry"
                    placeholder="Industry"
                    className="m-b"
                    tabIndex="38"
                    {...register("industry", { required: false })}
                  >
                    <option value="">Select</option>
                    <option value="Chemicals">Chemicals</option>
                    <option value="Constructions">Constructions</option>
                    <option value="Electronics">Electronics</option>
                    <option value="Energy">Energy</option>
                    <option value="Engineering">Engineering</option>
                    <option value="Environmental">Environmental</option>
                    <option value="Government">Government</option>
                    <option value="Manufacturing">Manufacturing</option>
                    <option value="Other">Other</option>
                    <option value="Shipping">Shipping</option>
                  </Form.Select>
                  {errors.industry && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              {/* <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Originiaze Import Break up (TPO/ %)	"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Originiaze Import Break up (TPO/ %)	"
                    name="originiaze_import_breakup"
                    {...register("originiaze_import_breakup", {
                      required: false,
                    })}
                  />
                  {errors.originiaze_import_breakup && <span>Required</span>}
                </FloatingLabel>
              </Form.Group> */}
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Sector"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="sector"
                    placeholder="Sector"
                    className="m-b"
                    tabIndex="39"
                    {...register("sector", { required: false })}
                  >
                    <option value="">Select</option>
                    <option value="Government">Government</option>
                    <option value="Power Sector">Power Sector</option>
                    <option value="Private Sector">Private Sector</option>
                    <option value="Industrial">Industrial</option>
                  </Form.Select>
                  {errors.sector && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Market impression rating"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    className="m-b"
                    placeholder="Market impression rating"
                    tabIndex="40"
                    name="market_impression_rating"
                    {...register("market_impression_rating", {
                      required: false,
                    })}
                  />
                  {errors.market_impression_rating && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>
            {/* product Information */}
            {/* <Row className="mb-3">
              <h4 className="heading">Product Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 1 3800 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 1 3800 GAR"
                    name="coal_spec_1_3800_GAR"
                    {...register("coal_spec_1_3800_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_1_3800_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 3 4700 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 3 4700 GAR"
                    name="coal_spec_3_4700_GAR"
                    {...register("coal_spec_3_4700_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_3_4700_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 2 4200 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 2 4200 GAR"
                    name="coal_spec_2_4200_GAR"
                    {...register("coal_spec_2_4200_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_2_4200_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingTextarea2"
                  label="Description"
                >
                  <Form.Control
                    as="textarea"
                    placeholder="Description"
                    style={{ height: "100px!important" }}
                    name="description"
                    {...register("description", { required: false })}
                  />
                  {errors.description && <p id="text-area">Required</p>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 4 5000 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 4 5000 GAR"
                    name="coal_spec_4_5000_GAR"
                    {...register("coal_spec_4_5000_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_4_5000_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>{" "}
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 5 5500 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 5 5500 GAR"
                    name="coal_spec_5_5500_GAR"
                    {...register("coal_spec_5_5500_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_5_5500_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 6"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 6"
                    name="coal_spec_6"
                    {...register("coal_spec_6", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_6 && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 7"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 7"
                    name="coal_spec_7"
                    {...register("coal_spec_7", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_7 && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 8"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 8"
                    name="coal_spec_8"
                    {...register("coal_spec_8", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_8 && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row> */}
            <Row className="mb-3">
              <h4 className="heading">System Information</h4>

        <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="account source"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="account_source"
                    placeholder="account source"
                    tabIndex="46"
                    {...register("account_source", { required: false })}
                  >
                  <option value="">--None--</option><option value="Advertisement">Advertisement</option><option value="Customer Event">Customer Event</option><option value="Employee Referral">Employee Referral</option><option value="Google AdWords">Google AdWords</option><option value="Other">Other</option><option value="Partner">Partner</option><option value="Purchased List">Purchased List</option><option value="Trade Show">Trade Show</option><option value="Webinar">Webinar</option><option value="Website">Website</option><option value="Rajgopalan">Rajgopalan</option><option value="Olivia">Olivia</option>
                  {errors.account_source && <span>Required</span>}
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>


        <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Rating"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="rating"
                    placeholder="Rating"
                    tabIndex="47"
                    {...register("rating", { required: false })}
                  >
                   <option value="">--None--</option><option value="Hot">Hot</option><option value="Warm">Warm</option><option value="Cold">Cold</option></Form.Select>
                  {errors.rating && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

            </Row>
            <Row className="mb-3">
              <h4 className="heading">Account Summary</h4>
              <Form.Group as={Col} md="12">
              <label>General terms</label>
              <Editor value={generalTerms} onChange={onChangeGeneralTerm} />
              </Form.Group>
            </Row>

            <p className='edit-cancel'><input
      type="submit"
      className="account-save"
      value={isFormsubmit ? "Saving" : "Save"}
      disabled={isFormsubmit}
    /><Link to={'/accounts/account-list'}><input type="submit" className="account-save" value="Cancel" /></Link></p>
            <div className="successDiv">
              <p></p><p></p>
            </div>
          </Form>

          <p></p><p></p>
          </div></div>
        </div>
        <Footer />
      </>
    );
  } else if (account_record === "Supplier") {
    const onSubmit = (data) => {
      setFormsubmited(true)
      const responseData = {
        account_name: data.account_name,
        account_alias: data.account_alias,
        payment_terms: paymentTerms,
        website: data.website,
        account_owner: data.account_owner,
        parent_account: data.parent_account,
        account_number: data.account_number,
        account_record_type: data.account_record_type,
        annual_revenue: parseInt(data.annual_revenue),
        no_of_employees: data.no_of_employees,
        port: data.port,
        origin: data.origin,
        remarks: data.remarks,
        product: data.product,
        general_terms: generalTerms,
        region: data.region,
        billing_street: pendingMatter,
        phone: data.phone,
        shipping_street: shippingAddress,
        billing_city: data.billing_city,
        shipping_postal_code: data.shipping_postal_code,
        shipping_city: data.shipping_city,
        shipping_state_or_province: data.shipping_state_or_province,
        shipping_country: data.shipping_country,
        billing_state_or_province: data.billing_state_or_province,
        billing_country: data.billing_country,
        billing_postal_code:data.billing_postal_code,
        fax: data.fax,
        KYC_docs: data.KYC_docs,
        KYC_doc_date: ky_date_date?ky_date_date:null,
         refrence_check_date:reference_date?reference_date:null,
        refrence_check: data.refrence_check,
        commitment: data.commitment,
        reliability: data.reliability,
        under_group: data.under_group,
        station_name: data.station_name,
        expansion_setup_or_buyer_status: data.expansion_setup_or_buyer_status,
        industry: data.industry,
        sector: data.sector,
        market_impression_rating: data.market_impression_rating,
        annual_coal_requirement_in_MT: data.annual_coal_requirement_in_MT,
        imported_volume_PA_in_MT: data.imported_volume_PA_in_MT,
        quantity_MT_monthly: data.quantity_MT_monthly,
        production_capacity: data.production_capacity,
        originiaze_import_breakup: data.originiaze_import_breakup,
        account_source: data.account_source,
        rating: data.rating,
        coal_spec_1_3800_GAR: data.coal_spec_1_3800_GAR,
        coal_spec_2_4200_GAR: data.coal_spec_2_4200_GAR,
        coal_spec_3_4700_GAR: data.coal_spec_3_4700_GAR,
        coal_spec_4_5000_GAR: data.coal_spec_4_5000_GAR,
        coal_spec_5_5500_GAR: data.coal_spec_5_5500_GAR,
        description: data.description,
        coal_spec_6: data.coal_spec_6,
        coal_spec_7: data.coal_spec_7,
        coal_spec_8: data.coal_spec_8,
        berth_details:berth,
        nomination_of_vessel:nomination,
        loading_demurge_and_dispatch_details:loadings,
        documents
      };
      console.log(JSON.stringify(responseData));
      const encryptedAccessToken = localStorage.getItem("access_token");
      const secret_key = "4d3a23fba54bbef1e14dd44ba9591612";
      if (encryptedAccessToken) {
        const decryptedAccessToken = AES.decrypt(
          encryptedAccessToken,
          secret_key
        ).toString(enc.Utf8);

        axios.post(`${API_URL}add/account`, responseData, {
          headers: {
            Authorization: `Bearer ${decryptedAccessToken}`,
            "Content-Type": "application/json",
          },
        })
          .then(response => {
            console.log(response);

            if (response.data.success === true) {
              document.getElementById('messageContainer').innerHTML = `
                  <div class="success-message">
                  ${response.data.message}
                  </div>
              `;

                window.scrollTo({
                  top: 0,
                  behavior: "smooth" // Optional: animated scrolling
              });


              navigate("/accounts/" + response.data.account_id);
          } else if (response.data.success === false) {

              document.getElementById('messageContainer').innerHTML = `
                  <div class="error-message">
                      ${response.data.message}
                  </div>
              `;

              // Scroll to the top of the page
              window.scrollTo({
                  top: 0,
                  behavior: "smooth" // Optional: animated scrolling
              });
          }
          })
          .catch(error => {
            // Handle errors
            console.error(error);
          });
      }
    };

    return (
      <>
        <Header />
        <div className="contactAccount  full-container">

         <div className="row">
       <div className="col-md-2 recent-item">
       <RecentItem/>
</div>
       <div className="col-md-10 right-section">
       <div className="page-header" id="add-account">
           <div>
             <h2 className="main-content-title tx-24 mg-b-5">Accounts </h2>
             <ol className="breadcrumb">
               <li className="breadcrumb-item active" aria-current="page">
                 Dashboard / Account/ Add Supplier
               </li>
             </ol>
           </div>

         </div>
          <Form onSubmit={handleSubmit(onSubmit)}>
          <div id="messageContainer"></div>
          <p className='edit-cancel'><input
      type="submit"
      className="account-save"
      value={isFormsubmit ? "Saving" : "Save"}
      disabled={isFormsubmit}
    /><Link to={'/accounts/account-list'}><input type="submit" className="account-save" value="Cancel" /></Link></p>

            <Row className="mb-3">
              <h4 className="heading">Account Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Name"
                    name="account_name"
                    tabIndex={1}
                    // defaultValue={account_name}
                    className="error-validation"
                    // onChange={(e) => setaccount_name(e.target.value)}
                    {...register("account_name", { required: true})}
                    />
                    {errors.account_name && <span>Error: You must enter a value </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Owner"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={7}
                    placeholder="Account Owner"
                    name="account_owner"
                    className="owner-role"
                    value={adminRole}
                    {...register("account_owner", { required: false })}
                  />
                  {errors.account_owner && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Alias"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Alias"
                    name="account_alias"
                    tabIndex={2}
                    {...register("account_alias", { required: false })}
                  />
                  {errors.account_alias && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Please Enter Full Company Name here</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>

              {/* <Form.Group as={Col} md="6"></Form.Group> */}
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account record type"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={8}
                    placeholder="Account record type"
                    value={account_record}
                    name="account_record_type" className='record-type'
                    {...register("account_record_type", { required: false })}
                  />
                  {errors.account_record_type && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Website"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Website"
                    name="website"
                    tabIndex={3}
                    {...register("website", { required: false })}
                  />
                  {errors.website && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>


              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Number"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Account Number"
                    tabIndex={9}
                    name="account_number"
                    {...register("account_number", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.account_number && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Trader"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Trader"
                    name="trader"
                    tabIndex={4}
                    {...register("trader", { required: false })}
                  />
                  {errors.trader && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Trader</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="No of employees"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="No of employees"
                    tabIndex={10}
                    name="no_of_employees"
                    {...register("no_of_employees", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.no_of_employees && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>


              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Product"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Product"
                    name="product"
                    tabIndex={5}
                    {...register("product", { required: false })}
                  />
                  {errors.product && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">

              </Form.Group>

              {/* <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="No of employees"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="No of employees"
                    name="no_of_employees"
                    {...register("no_of_employees", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.no_of_employees && <span>Required</span>}
                </FloatingLabel>
              </Form.Group> */}


              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Remarks"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Remarks"
                    name="remarks"
                    tabIndex={6}
                    {...register("remarks", { required: false })}
                  />
                  {errors.remarks && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
            </Row>
            <Row className="mb-3">
              <h4 className="heading">Address Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Region"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Region"
                    name="region"
                    tabIndex={11}
                    {...register("region", { required: false })}
                  />
                  {errors.region && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
              </Form.Group>

              <Form.Group as={Col} md="6" className="textarea-half b-t">
              <label>Billing Address</label>
              <Editor value={pendingMatter} onChange={onChangePending} tabIndex={12}/>
              </Form.Group>

              <Form.Group as={Col} md="6" className="textarea-half b-t">
              <label>Shipping Address</label>
              <Editor value={shippingAddress} onChange={onChangeShippingAddress} tabIndex={17}/>
              </Form.Group>


              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing postal code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing postal code"
                    name="billing_postal_code"
                    tabIndex={13}
                    {...register("billing_postal_code", { required: false })}
                  />
                  {errors.billing_postal_code && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping postal code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping postal code"
                    tabIndex={18}
                    name="shipping_postal_code"
                    {...register("shipping_postal_code", { required: false })}
                  />
                  {errors.shipping_postal_code && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing city"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing city"
                    name="billing_city"
                    tabIndex={14}
                    {...register("billing_city", { required: false })}
                  />
                  {errors.billing_city && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping city"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping city"
                    name="shipping_city"
                    tabIndex={19}
                    {...register("shipping_city", { required: false })}
                  />
                  {errors.shipping_city && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>


              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing state province"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing state province"
                    tabIndex={15}
                    name="billing_state_or_province"
                    {...register("billing_state_or_province", {
                      required: false,
                    })}
                  />
                  {errors.billing_state_or_province && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping state province"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping state province"
                    name="shipping_state_or_province"
                    tabIndex={20}
                    {...register("shipping_state_or_province", {
                      required: false,
                    })}
                  />
                  {errors.shipping_state_or_province && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>


              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing country"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing country"
                    name="billing_country"
                    tabIndex={16}
                    {...register("billing_country", { required: false })}
                  />
                  {errors.billing_country && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping country"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping country"
                    name="shipping_country"
                    tabIndex={21}
                    {...register("shipping_country", { required: false })}
                  />
                  {errors.shipping_country && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <h4 className="heading">KYC Documents</h4>
               {documents.map((document, index) => (
        <>

          <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Document Name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={22}
                    placeholder="Document Name"
                    defaultValue={document.name}
                    onChange={(e) => handleDocumentChange(index, 'document_name', e.target.value)}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Validity"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={23}
                    placeholder="Validity"
                    defaultValue={document.validity}
                    onChange={(e) => handleDocumentChange(index, 'validity', e.target.value)}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="1">
          {index > 0 && (
            <span id="links" onClick={() => handleRemoveDocument(index)}><FaTrashAlt/></span>
          )}
          </Form.Group>
        </>
      ))}
      <span id="links" onClick={handleAddDocument}>Add Document</span>
      {/* <button onClick={handleSubmit}>Create Account</button> */}
              </Row>
            <Row className="mb-3">
              <h4 className="heading">Rwood Reference</h4>
              <Form.Group as={Col} md="6">
        <FloatingLabel
          controlId="floatingInput"
          label="Refrence Check Date"
          className="mb-3 datepick"


        >
           <DatePicker
        selected={startDate}
        onChange={handleStartDateChange}
        selectsStart
        dateFormat='dd/MM/yyyy'
        tabIndex={24}
        startDate={startDate} placeholderText="Select"
      />
        </FloatingLabel>
      </Form.Group>
        <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Commitment"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="commitment"
                    placeholder="Commitment"
                    tabIndex={28}
                    defaultValue=""
                    {...register("commitment", { required: false })}
                  >
                    <option value="">--None--</option><option value="Medium Term">Medium Term</option><option value="Short Term">Short Term</option><option value="Long Term">Long Term</option><option value="Promptly">Promptly</option>
                  </Form.Select>
                  {errors.commitment && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Refrence check"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Refrence check"
                    tabIndex={25}
                    name="refrence_check"
                    {...register("refrence_check", { required: false })}
                  />
                  {errors.refrence_check && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Reliability"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Reliability"
                    name="reliability"
                    tabIndex={29}
                    {...register("reliability", { required: false })}
                  />
                  {errors.reliability && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="KYC docs"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="KYC docs"
                    name="KYC_docs"
                    tabIndex={26}
                    {...register("KYC_docs", { required: false })}
                  />
                  {errors.KYC_docs && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6"></Form.Group>

   <Form.Group as={Col} md="6">
        <FloatingLabel
          controlId="floatingInput"
          label="KYC Doc date"
          className="mb-3 datepick"


        >
           <DatePicker
        selected={kycdoc}
        tabIndex={27}
        onChange={handleStartDateKyc}
        dateFormat='dd/MM/yyyy'
        startDate={kycdoc} placeholderText="Select"
      />
        </FloatingLabel>
      </Form.Group>
        <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Rating"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="rating"
                    placeholder="Rating"
                    tabIndex={30}
                    defaultValue=""
                    {...register("rating", { required: false })}
                  >
                   <option value="">--None--</option><option value="Hot">Hot</option><option value="Warm">Warm</option><option value="Cold">Cold</option></Form.Select>
                  {errors.rating && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

            </Row>
            <Row className="mb-3">
              <h4 className="heading">Industry Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Parent account"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Parent account"
                    name="parent_account"
                    tabIndex={31}
                    {...register("parent_account", { required: false })}
                  />
                  {errors.parent_account && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="annual coal requirement in  MT"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="annual coal requirement in  MT"
                    name="annual_coal_requirement_in_MT"
                    tabIndex={36}
                    {...register("annual_coal_requirement_in_MT", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.annual_coal_requirement_in_MT && (
                    <span>Required</span>
                  )}
                </FloatingLabel>
                <Tooltip text={<span>in MT</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Under group"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Under group"
                    tabIndex={32}
                    name="under_group"
                    {...register("under_group", { required: false })}
                  />
                  {errors.under_group && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Imported volume PA in MT"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Imported volume PA in MT"
                    name="imported_volume_PA_in_MT"
                    tabIndex={37}
                    {...register("imported_volume_PA_in_MT", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.imported_volume_PA_in_MT && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>{" "}
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Expansion setup or buyer status"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="expansion_setup_or_buyer_status"
                    tabIndex={33}
                    placeholder="Expansion setup or buyer status"
                    defaultValue=""
                    {...register("expansion_setup_or_buyer_status", {
                      required: false,
                    })}
                  >
                    <option value="">Select</option>
                    <option value="Under Construction">
                      Under Construction
                    </option>
                    <option value="Operated">Operated</option>
                    <option value="Permitted">Permitted</option>
                  </Form.Select>
                  {errors.expansion_setup_or_buyer_status && (
                    <span>Required</span>
                  )}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Quantity MT monthly"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Quantity MT monthly"
                    name="quantity_MT_monthly"
                    tabIndex={38}
                    {...register("quantity_MT_monthly", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.quantity_MT_monthly && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              {/* <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Expansion setup or buyer status"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="expansion_setup_or_buyer_status"
                    placeholder="Expansion setup or buyer status"
                    defaultValue=""
                    {...register("expansion_setup_or_buyer_status", {
                      required: false,
                    })}
                  >
                    <option value="">Select</option>
                    <option value="Under Construction">
                      Under Construction
                    </option>
                    <option value="Operated">Operated</option>
                    <option value="Permitted">Permitted</option>
                  </Form.Select>
                  {errors.expansion_setup_or_buyer_status && (
                    <span>Required </span>
                  )}
                </FloatingLabel>
              </Form.Group> */}
              <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Production /Capacity Utilisation (Unit %"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Production /Capacity Utilisation (Unit %"
                    name="production_capacity"
                    tabIndex={39}
                    {...register("production_capacity", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.production_capacity && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Sector"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="sector"
                    tabIndex={34}
                    placeholder="Sector"
                    defaultValue=""
                    {...register("sector", { required: false })}
                  >
                    <option value="">Select</option>
                    <option value="Chemicals">Chemicals</option>
                    <option value="Constructions">Constructions</option>
                    <option value="Electronics">Electronics</option>
                    <option value="Energy">Energy</option>
                    <option value="Engineering">Engineering</option>
                    <option value="Environmental">Environmental</option>
                    <option value="Government">Government</option>
                    <option value="Manufacturing">Manufacturing</option>
                    <option value="Other">Other</option>
                    <option value="Shipping">Shipping</option>
                  </Form.Select>
                  {errors.sector && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Originiaze Import Break up (TPO/ %)	"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Originiaze Import Break up (TPO/ %)	"
                    name="originiaze_import_breakup"
                    tabIndex={40}
                    {...register("originiaze_import_breakup", {
                      required: false,
                    })}
                  />
                  {errors.originiaze_import_breakup && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Market impression rating"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Market impression rating"
                    name="market_impression_rating"
                    tabIndex={35}
                    {...register("market_impression_rating", {
                      required: false,
                    })}
                  />
                  {errors.market_impression_rating && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Port"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Port"
                    tabIndex={41}
                    name="port"
                    {...register("port", { required: false })}
                  />
                  {errors.port && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Origin"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Origin"
                    name="origin"
                    tabIndex={42}
                    {...register("origin", { required: false })}
                  />
                  {errors.origin && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

            </Row>
            {/* product Information */}
            {/* <Row className="mb-3">
              <h4 className="heading">Product Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 1 3800 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 1 3800 GAR"
                    name="coal_spec_1_3800_GAR"
                    {...register("coal_spec_1_3800_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_1_3800_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 3 4700 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 3 4700 GAR"
                    name="coal_spec_3_4700_GAR"
                    {...register("coal_spec_3_4700_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_3_4700_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 2 4200 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 2 4200 GAR"
                    name="coal_spec_2_4200_GAR"
                    {...register("coal_spec_2_4200_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_2_4200_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingTextarea2"
                  label="Description"
                >
                  <Form.Control
                    as="textarea"
                    placeholder="Description"
                    style={{ height: "100px!important" }}
                    name="description"
                    {...register("description", { required: false })}
                  />
                  {errors.description && <p id="text-area">Required</p>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 4 5000 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 4 5000 GAR"
                    name="coal_spec_4_5000_GAR"
                    {...register("coal_spec_4_5000_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_4_5000_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>{" "}
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 5 5500 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 5 5500 GAR"
                    name="coal_spec_5_5500_GAR"
                    {...register("coal_spec_5_5500_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_5_5500_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 6"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 6"
                    name="coal_spec_6"
                    {...register("coal_spec_6", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_6 && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 7"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 7"
                    name="coal_spec_7"
                    {...register("coal_spec_7", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_7 && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 8"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 8"
                    name="coal_spec_8"
                    {...register("coal_spec_8", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_8 && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row> */}
            <Row className="mb-3">
              <h4 className="heading">Terms and Conditions</h4>
               <Form.Group as={Col} md="12">
              <label>Nomination of Vessel</label>
              <Editor value={nomination} onChange={onChangeNomination} tabIndex={43}/>
              </Form.Group>
              <Form.Group as={Col} md="12">
              <label>Berth Details</label>
              <Editor value={berth} onChange={onChangeBerth} tabIndex={46}/>
              </Form.Group>
            
              <Form.Group as={Col} md="12">
              <label>Loading Demurrage and Despatch Details</label>
              <Editor value={loadings} onChange={onChangeLoadings} tabIndex={44} />
              </Form.Group>
            
          

              <Form.Group as={Col} md="12">
              <label>General terms</label>
              <Editor value={generalTerms} onChange={onChangeGeneralTerm} tabIndex={47} />
              </Form.Group>
              <Form.Group as={Col} md="12">
              <label>Payment terms</label>
              <Editor value={paymentTerms} onChange={onChangePaymentTerm} tabIndex={45}/>
              </Form.Group><br/>
            </Row>
            <Row className="mb-3">
              <h4 className="heading">System Information</h4>

        <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="account source"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="account_source"
                    placeholder="account source"
                    tabIndex={48}
                    defaultValue=""
                    {...register("account_source", { required: false })}
                  >
                  <option value="">--None--</option><option value="Advertisement">Advertisement</option><option value="Customer Event">Customer Event</option><option value="Employee Referral">Employee Referral</option><option value="Google AdWords">Google AdWords</option><option value="Other">Other</option><option value="Partner">Partner</option><option value="Purchased List">Purchased List</option><option value="Trade Show">Trade Show</option><option value="Webinar">Webinar</option><option value="Website">Website</option><option value="Rajgopalan">Rajgopalan</option><option value="Olivia">Olivia</option>
                  {errors.account_source && <span>Required</span>}
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>


            </Row>


            <p className='edit-cancel'><input
      type="submit"
      className="account-save"
      value={isFormsubmit ? "Saving" : "Save"}
      disabled={isFormsubmit}
    /><Link to={'/accounts/account-list'}><input type="submit" className="account-save" value="Cancel" /></Link></p>
            <div className="successDiv">
              <p></p><p></p>
            </div>
          </Form>
          <p></p><p></p>
        </div>
        </div>
        </div>
        <Footer />
      </>
    );

    //
  } else if (account_record === "Bank") {
    const bankPage = (data) => {
      const responseData = {
        account_name: data.account_name,
        account_alias: data.account_alias,
        port: data.port,
        company:companydrop.value,
        origin: data.origin,
        product: data.product,
        remarks: data.remarks,
        account_record_type: data.account_record_type,
        account_owner: data.account_owner,
        parent_account: data.parent_account,
        fax: data.fax,
        phone: data.phone,
        employees: data.employees,
        shipping_street: shippingAddress,
        billing_street: pendingMatter,
        shipping_postal_code: data.shipping_postal_code,
        billing_postal_code: data.billing_postal_code,
        billing_city: data.billing_city,
        billing_state_or_province:data.billing_state_or_province,
        shipping_state_or_province:data.shipping_state_or_province,
        shipping_city: data.shipping_city,
        shipping_country: data.shipping_country,
        billing_country: data.billing_country,
        documents
      };
      console.log(JSON.stringify(responseData));
      const encryptedAccessToken = localStorage.getItem("access_token");
      const secret_key = "4d3a23fba54bbef1e14dd44ba9591612";
      if (encryptedAccessToken) {
        const decryptedAccessToken = AES.decrypt(
          encryptedAccessToken,
          secret_key
        ).toString(enc.Utf8);

        axios.post(`${API_URL}add/account`, responseData, {
          headers: {
            Authorization: `Bearer ${decryptedAccessToken}`,
            "Content-Type": "application/json",
          },
        })
          .then(response => {
            console.log(response);

            if (response.data.success === true) {
              document.getElementById('messageContainer').innerHTML = `
                  <div class="success-message">
                  ${response.data.message}
                  </div>
              `;

                window.scrollTo({
                  top: 0,
                  behavior: "smooth" // Optional: animated scrolling
              });


              navigate("/accounts/" + response.data.account_id);
          } else if (response.data.success === false) {

              document.getElementById('messageContainer').innerHTML = `
                  <div class="error-message">
                      ${response.data.message}
                  </div>
              `;

              // Scroll to the top of the page
              window.scrollTo({
                  top: 0,
                  behavior: "smooth" // Optional: animated scrolling
              });
          }
          })
          .catch(error => {
            // Handle errors
            console.error(error);
          });
      }
    };

    return (
      <>
        <Header />
        <div className="contactAccount  full-container">

          <div className="row">
        <div className="col-md-2 recent-item">
        <RecentItem/>
</div>
        <div className="col-md-10 right-section">

        <div className="page-header" id="add-account">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Accounts </h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">
                  Dashboard / Account/ Add Agent
                </li>
              </ol>
            </div>

          </div>
          <Form onSubmit={handleSubmit2(bankPage)}>
          <div id="messageContainer"></div>
          <p className='edit-cancel'><input
      type="submit"
      className="account-save"
      value={isFormsubmit ? "Saving" : "Save"}
      disabled={isFormsubmit}
    /><Link to={'/accounts/account-list'}><input type="submit" className="account-save" value="Cancel" /></Link></p>
            <Row className="mb-3">
              <h4 className="heading">Account Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Name"
                  className="mb-3"
                >
                <Form.Control
                    type="text"
                    placeholder="Account Name"
                    name="account_name"
                    tabIndex="1"
                    // defaultValue={account_name}
                    className="error-validation"
                    // onChange={(e) => setaccount_name(e.target.value)}
                    {...register2("account_name", { required: true })}
                    />
                    {errors2.account_name && <span>Error: You must enter a value
 </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account record type"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account record type"
                    value={account_record}
                    tabIndex="9"
                    name="account_record_type" className='record-type'
                    {...register2("account_record_type", { required: false })}
                  />
                  {errors2.account_record_type && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>


              <Form.Group as={Col} md="6">

              <Select
        options={optionsCompany}
        value={companydrop}
        onChange={handleCompany}
        tabIndex="2"
        placeholder="Company"
      />



            </Form.Group>

               <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Owner"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Owner"
                    name="account_owner"
                    className="owner-role"
                    value={adminRole}
                    tabIndex="10"
                    {...register2("account_owner", { required: false })}
                  />
                  {errors2.account_owner && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Alias"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Alias"
                    name="account_alias"
                    tabIndex="3"
                    {...register2("account_alias", { required: false })}
                  />
                  {errors2.account_alias && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Please Enter Full Company Name here</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Parent Account"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Parent Account"
                    name="parent_account"
                    tabIndex="11"
                    {...register2("parent_account", { required: false })}
                  />
                  {errors2.parent_account && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Port"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Port"
                    name="port"
                    tabIndex="4"
                    {...register2("port", { required: false })}
                  />
                  {errors2.port && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Fax"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Fax"
                    name="fax"
                    tabIndex="12"
                    {...register2("fax", { required: false })}
                  />
                  {errors2.fax && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Origin"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Origin"
                    name="origin"
                    tabIndex="5"
                    {...register2("origin", { required: false })}
                  />
                  {errors2.origin && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Phone"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Phone"
                    name="phone"
                    tabIndex="13"
                    {...register2("phone", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors2.phone && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Phone numbers are a great way to call people on phones. <br/> Phones are what we call our pocket computers <br/>even though we use them for games, selfies,<br/> and facebook.</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Product"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Product"
                    name="product"
                    tabIndex="6"
                    {...register2("product", { required: false })}
                  />
                  {errors2.product && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Employees"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Employees"
                    name="employees"
                    tabIndex="14"
                    {...register2("employees", { required: false })}
                  />
                  {errors2.employees && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Remarks"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Remarks"
                    name="remarks"
                    tabIndex="7"
                    {...register2("remarks", { required: false })}
                  />
                  {errors2.remarks && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" className="tools"></Form.Group>
              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Trader"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Trader"
                    name="trader"
                    tabIndex="8"
                    {...register2("trader", { required: false })}
                  />
                  {errors2.trader && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Trader</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>

            </Row>

            <Row className="mb-3">
              <h4 className="heading">KYC Documents</h4>
               {documents.map((document, index) => (
        <>

          <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Document Name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Document Name"
                    tabIndex="15"
                    defaultValue={document.name}
                    onChange={(e) => handleDocumentChange(index, 'document_name', e.target.value)}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Validity"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Validity"
                    tabIndex="16"
                    defaultValue={document.validity}
                    onChange={(e) => handleDocumentChange(index, 'validity', e.target.value)}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="1">
          {index > 0 && (
            <span id="links" onClick={() => handleRemoveDocument(index)}><FaTrashAlt/></span>
          )}
          </Form.Group>
        </>
      ))}
      <span id="links" onClick={handleAddDocument}>Add Document</span>
      {/* <button onClick={handleSubmit}>Create Account</button> */}
              </Row>
            <Row className="mb-3">
              <h4 className="heading">Address Information</h4>
              <Form.Group as={Col} md="6" className="textarea-half b-t">
              <label>Billing Address</label>
              <Editor value={pendingMatter} tabIndex="18" onChange={onChangePending} />
              </Form.Group>

              <Form.Group as={Col} md="6" className="textarea-half b-t">
              <label>Shipping Address</label>
              <Editor value={shippingAddress} tabIndex="22" onChange={onChangeShippingAddress} />
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing postal code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing postal code"
                    name="billing_postal_code"
                    tabIndex="19"
                    {...register2("billing_postal_code", { required: false })}
                  />
                  {errors2.billing_postal_code && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping postal code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping postal code"
                    name="shipping_postal_code"
                    tabIndex="23"
                    {...register2("shipping_postal_code", { required: false })}
                  />
                  {errors2.shipping_postal_code && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing city"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing city"
                    name="billing_city"
                    tabIndex="20"
                    {...register2("billing_city", { required: false })}
                  />
                  {errors2.billing_city && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping city"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping city"
                    name="shipping_city"
                    tabIndex="24"
                    {...register2("shipping_city", { required: false })}
                  />
                  {errors2.shipping_city && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing state province"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing state province"
                    name="billing_state_or_province"
                    tabIndex="21"
                    {...register2("billing_state_or_province", {
                      required: false,
                    })}
                  />
                  {errors2.billing_state_or_province && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping state province"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping state province"
                    name="shipping_state_or_province"
                    tabIndex="25"
                    {...register2("shipping_state_or_province", {
                      required: false,
                    })}
                  />
                  {errors2.shipping_state_or_province && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing country"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing country"
                    name="billing_country"
                    tabIndex="22"
                    {...register2("billing_country", { required: false })}
                  />
                  {errors2.billing_country && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping country"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing country"
                    name="shipping_country"
                    tabIndex="26"
                    {...register2("shipping_country", { required: false })}
                  />
                  {errors2.shipping_country && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>

            <p className='edit-cancel'><input
      type="submit"
      className="account-save"
      value={isFormsubmit ? "Saving" : "Save"}
      disabled={isFormsubmit}
    /><Link to={'/accounts/account-list'}><input type="submit" className="account-save" value="Cancel" /></Link></p>
            <div className="successDiv">
              <p></p><p></p>
            </div>
          </Form>
          <p></p><p></p>
          </div></div></div>
        <Footer />
      </>
    );
  }

  else if (account_record === "Buyer") {
    const buyer = (data) => {
      const responseData = {
        account_name: data.account_name,
        account_alias: data.account_alias,
        imported_volume_from_indonesia_PA_in_MT:parseInt(
          data.imported_volume_from_indonesia_PA_in_MT),
        website: data.website,
        account_owner: data.account_owner,
        parent_account: data.parent_account,
        account_number: parseInt(data.account_number),
        account_record_type: data.account_record_type,
        annual_revenue: parseInt(data.annual_revenue),
        no_of_employees: data.no_of_employees,
        port: data.port,
        payment_terms: paymentTerms,
        origin: data.origin,
        remarks: data.remarks,
        product: data.product,
        general_terms: generalTerms,
        region: data.region,
        billing_street: pendingMatter,
        phone: data.phone,
        shipping_street: shippingAddress,
        billing_city: data.billing_city,
        shipping_postal_code: data.shipping_postal_code,
        shipping_city: data.shipping_city,
        shipping_state_or_province: data.shipping_state_or_province,
        shipping_country: data.shipping_country,
        billing_state_or_province: data.billing_state_or_province,
        billing_country: data.billing_country,
        fax: data.fax,
        description: data.description,
        KYC_docs: data.KYC_docs,
        KYC_doc_date: ky_date_date?ky_date_date:null,
        refrence_check_date:reference_date?reference_date:null,
        refrence_check: data.refrence_check,
        commitment: data.commitment,
        reliability: data.reliability,
        under_group: data.under_group,
        station_name: data.station_name,
        expansion_setup_or_buyer_status: data.expansion_setup_or_buyer_status,
        industry: data.industry,
        sector: data.sector,
        market_impression_rating: data.market_impression_rating,
        annual_coal_requirement_in_MT: data.annual_coal_requirement_in_MT,
        imported_volume_PA_in_MT: data.imported_volume_PA_in_MT,
        quantity_MT_monthly: data.quantity_MT_monthly,
        production_capacity: data.production_capacity,
        originiaze_import_breakup: data.originiaze_import_breakup,
        account_source: data.account_source,
        rating: data.rating,

        coal_spec_1_3800_GAR: data.coal_spec_1_3800_GAR,
        coal_spec_2_4200_GAR: data.coal_spec_2_4200_GAR,
        coal_spec_3_4700_GAR: data.coal_spec_3_4700_GAR,
        coal_spec_4_5000_GAR: data.coal_spec_4_5000_GAR,
        coal_spec_5_5500_GAR: data.coal_spec_5_5500_GAR,
        coal_spec_6: data.coal_spec_6,
        coal_spec_7: data.coal_spec_7,
        coal_spec_8: data.coal_spec_8,
        documents
      };

      console.log(JSON.stringify(responseData))
      const encryptedAccessToken = localStorage.getItem("access_token");
      const secret_key = "4d3a23fba54bbef1e14dd44ba9591612";
      if (encryptedAccessToken) {
        const decryptedAccessToken = AES.decrypt(
          encryptedAccessToken,
          secret_key
        ).toString(enc.Utf8);

        axios.post(`${API_URL}add/account`, responseData, {
          headers: {
            Authorization: `Bearer ${decryptedAccessToken}`,
            "Content-Type": "application/json",
          },
        })
          .then(response => {
            console.log(response);

            if (response.data.success === true) {
              document.getElementById('messageContainer').innerHTML = `
                  <div class="success-message">
                  ${response.data.message}
                  </div>
              `;

                window.scrollTo({
                  top: 0,
                  behavior: "smooth" // Optional: animated scrolling
              });


              navigate("/accounts/" + response.data.account_id);
          } else if (response.data.success === false) {

              document.getElementById('messageContainer').innerHTML = `
                  <div class="error-message">
                      ${response.data.message}
                  </div>
              `;

              // Scroll to the top of the page
              window.scrollTo({
                  top: 0,
                  behavior: "smooth" // Optional: animated scrolling
              });
          }
          })
          .catch(error => {
            // Handle errors
            console.error(error);
          });
      }
    };
    return (
      <>
        <Header />
       <div className="contactAccount  full-container">

          <div className="row">
        <div className="col-md-2 recent-item">
        <RecentItem/>
</div>
        <div className="col-md-10 right-section">
        <div className="page-header" id="add-account">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Accounts </h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">
                  Dashboard / Account/ Add Buyer
                </li>
              </ol>
            </div>

          </div>
          <Form onSubmit={handleSubmit4(buyer)}>
          <div id="messageContainer"></div>
          <p className='edit-cancel'><input
      type="submit"
      className="account-save"
      value={isFormsubmit ? "Saving" : "Save"}
      disabled={isFormsubmit}
    /><Link to={'/accounts/account-list'}><input type="submit" className="account-save" value="Cancel" /></Link></p>
            <Row className="mb-3">
              <h4 className="heading">Account Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Name"
                  className="mb-3"
                >
                   <Form.Control
                    type="text"
                    placeholder="Account Name"
                    name="account_name"
                    // defaultValue={account_name}
                    className="error-validation"
                    tabIndex="1"
                    // onChange={(e) => setaccount_name(e.target.value)}
                    {...register4("account_name", { required: true })}
                    />
                    {errors4.account_name && <span>Error: You must enter a value </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Owner"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Owner"
                    name="account_owner"
                    value={adminRole}
                    tabIndex="5"
                    className="owner-role"
                    {...register4("account_owner", { required: false })}
                  />
                  {errors4.account_owner && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Alias"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Alias"
                    name="account_alias"
                    tabIndex="2"
                    className="error-validation"
                    {...register4("account_alias", { required: true })}
                  />
                  {errors4.account_alias && <span>Error: You must enter a value</span>}
                </FloatingLabel>
                <Tooltip text={<span>Please Enter Full Company Name here</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Parent Account"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Parent Account"
                    name="parent_account"
                    tabIndex="6"
                    {...register4("parent_account", { required: false })}
                  />
                  {errors4.parent_account && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Website"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Website"
                    name="website"
                    tabIndex="3"
                    {...register4("website", { required: false })}
                  />
                  {errors4.website && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Number"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Number"
                    name="account_number"
                    tabIndex="7"
                    {...register4("account_number", { required: false })}
                  />
                  {errors4.account_number && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Trader"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Trader"
                    name="trader"
                    tabIndex="4"
                    {...register4("trader", { required: false })}
                  />
                  {errors4.trader && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Trader</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account record type"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account record type"
                    value={account_record}
                    tabIndex="8"
                    name="account_record_type" className='record-type'
                    {...register4("account_record_type", { required: false })}
                  />
                  {errors4.account_record_type && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
             <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Annual Revenue"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Annual Revenue"
                    name="annual_revenue"
                    tabIndex="9"
                    {...register4("annual_revenue", { required: false })}
                  />
                  {errors4.annual_revenue && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
               <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="No of employees"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="No of employees"
                    name="no_of_employees"
                    tabIndex="10"
                    {...register4("no_of_employees", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.no_of_employees && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>
            <Row>
              <h4 className="heading">Address Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Region"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Region"
                    name="region"
                    tabIndex="11"
                    {...register4("region", { required: false })}
                  />
                  {errors4.region && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6" className="textarea-half b-t">
              <label>Billing Address</label>
              <Editor value={pendingMatter} tabIndex="12" onChange={onChangePending} />
              </Form.Group>
              <Form.Group as={Col} md="6" className="textarea-half b-t">
              <label>Shipping Address</label>
              <Editor value={shippingAddress} tabIndex="18" onChange={onChangeShippingAddress} />
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing postal code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing postal code"
                    name="billing_postal_code"
                    tabIndex="13"
                    {...register4("billing_postal_code", { required: false })}
                  />
                  {errors4.billing_postal_code && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping postal code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping postal code"
                    name="shipping_postal_code"
                    tabIndex="19"
                    {...register4("shipping_postal_code", { required: false })}
                  />
                  {errors4.shipping_postal_code && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing city"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing city"
                    name="billing_city"
                    tabIndex="14"
                    {...register4("billing_city", { required: false })}
                  />
                  {errors4.billing_city && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping city"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping city"
                    name="shipping_city"
                    tabIndex="20"
                    {...register4("shipping_city", { required: false })}
                  />
                  {errors4.shipping_city && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing state province"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing state province"
                    name="billing_state_or_province"
                    tabIndex="15"
                    {...register4("billing_state_or_province", {
                      required: false,
                    })}
                  />
                  {errors4.billing_state_or_province && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping state province"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping state province"
                    name="shipping_state_or_province"
                    tabIndex="21"
                    {...register4("shipping_state_or_province", {
                      required: false,
                    })}
                  />
                  {errors4.shipping_state_or_province && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing country"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing country"
                    name="billing_country"
                    tabIndex="16"
                    {...register4("billing_country", { required: false })}
                  />
                  {errors4.billing_country && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping country"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing country"
                    name="shipping_country"
                    tabIndex="22"
                    {...register4("shipping_country", { required: false })}
                  />
                  {errors4.shipping_country && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Phone"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Phone"
                    name="phone"
                    tabIndex="17"
                    {...register4("phone", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.phone && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Phone numbers are a great way to call people on phones. <br/> Phones are what we call our pocket computers <br/>even though we use them for games, selfies,<br/> and facebook.</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Fax"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="fax"
                    name="fax"
                    tabIndex="23"
                    {...register4("fax", { required: false })}
                  />
                  {errors4.fax && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <h4 className="heading">KYC Documents</h4>
               {documents.map((document, index) => (
        <>

          <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Document Name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Document Name"
                    tabIndex="24"
                    defaultValue={document.name}
                    onChange={(e) => handleDocumentChange(index, 'document_name', e.target.value)}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Validity"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Validity"
                    tabIndex="24"
                    defaultValue={document.validity}
                    onChange={(e) => handleDocumentChange(index, 'validity', e.target.value)}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="1">
          {index > 0 && (
            <span id="links" onClick={() => handleRemoveDocument(index)}><FaTrashAlt/></span>
          )}
          </Form.Group>
        </>
      ))}
      <span id="links" onClick={handleAddDocument}>Add Document</span>
      {/* <button onClick={handleSubmit}>Create Account</button> */}
              </Row>
            <Row className="mb-3">
              <h4 className="heading">Rwood Reference</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="KYC docs"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="KYC docs"
                    name="KYC_docs"
                    tabIndex="25"
                    {...register4("KYC_docs", { required: false })}
                  />
                  {errors4.KYC_docs && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Commitment"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="commitment"
                    placeholder="Commitment"
                    tabIndex="29"
                    {...register4("commitment", { required: false })}
                  >
                    <option value="">Select</option>
                    <option value="Minimum Term">Minimum Term</option>
                    <option value="Short Term">Short Term</option>
                    <option value="Long Term">Long Term</option>
                  </Form.Select>
                  {errors4.commitment && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
        <FloatingLabel
          controlId="floatingInput"
          label="KYC Doc date"
          className="mb-3 datepick"


        >
           <DatePicker
        selected={kycdoc}
        onChange={handleStartDateKyc}
        dateFormat='dd/MM/yyyy'
        tabIndex="26"
        startDate={kycdoc} placeholderText="Select"
      />
        </FloatingLabel>
      </Form.Group>
      <Form.Group as={Col} md="6"  className="textarea-half">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Reliability"
                  className="mb-3"
                >
                  <Form.Control
                    as="textarea"
                    placeholder="Reliability"
                    name="reliability"
                    tabIndex="30"
                    {...register4("reliability", { required: false })}
                  />
                  {errors4.reliability && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Refrence check"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Refrence check"
                    name="refrence_check"
                    tabIndex="27"
                    {...register4("refrence_check", { required: false })}
                  />
                  {errors4.refrence_check && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>

<Form.Group as={Col} md="6">
       <FloatingLabel
          controlId="floatingInput"
          label="Refrence Check Date"
          className="mb-3 datepick"


        >
           <DatePicker
        selected={startDate}
        onChange={handleStartDateChange}
        selectsStart
        dateFormat='dd/MM/yyyy'
        tabIndex="28"
        startDate={startDate} placeholderText="Select"
      />
        </FloatingLabel>
      </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
            </Row>

            <Row className="mb-3">
              <h4 className="heading">Industry Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Under group"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Under group"
                    name="under_group"
                    tabIndex="31"
                    {...register4("under_group", { required: false })}
                  />
                  {errors4.under_group && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="annual coal requirement in  MT"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="annual coal requirement in  MT"
                    name="annual_coal_requirement_in_MT"
                    tabIndex="37"
                    {...register4("annual_coal_requirement_in_MT", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.annual_coal_requirement_in_MT && (
                    <span>Required</span>
                  )}
                </FloatingLabel>
                <Tooltip text={<span>in MT</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Station name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Station name"
                    name="station_name"
                    tabIndex="32"
                    {...register4("station_name", { required: false })}
                  />
                  {errors4.station_name && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Imported volume PA in MT"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Imported volume PA in MT"
                    name="imported_volume_PA_in_MT"
                    tabIndex="38"
                    {...register4("imported_volume_PA_in_MT", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.imported_volume_PA_in_MT && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Expansion setup or buyer status"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="expansion_setup_or_buyer_status"
                    tabIndex="33"
                    placeholder="Expansion setup or buyer status"
                    defaultValue=""
                    {...register4("expansion_setup_or_buyer_status", {
                      required: false,
                    })}
                  >
                    <option value="">Select</option>
                    <option value="Under Construction">
                      Under Construction
                    </option>
                    <option value="Operated">Operated</option>
                    <option value="Permitted">Permitted</option>
                  </Form.Select>
                  {errors4.expansion_setup_or_buyer_status && (
                    <span>Required </span>
                  )}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Imported volume from indonesia PA in MT"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Imported volume from indonesia PA in MT"
                    name="imported_volume_from_indonesia_PA_in_MT"
                    tabIndex="39"
                    {...register4("imported_volume_from_indonesia_PA_in_MT", {
                      required: false,
                    })}
                  />
                  {errors4.imported_volume_from_indonesia_PA_in_MT && (
                    <span>Required</span>
                  )}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Quantity MT monthly"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Quantity MT monthly"
                    name="quantity_MT_monthly"
                    tabIndex="39"
                    {...register4("quantity_MT_monthly", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.quantity_MT_monthly && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Industry"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="industry"
                    placeholder="Industry"
                    tabIndex="34"
                    {...register4("industry", { required: false })}
                  >
                    <option value="">Select</option>
                    <option value="Chemicals">Chemicals</option>
                    <option value="Constructions">Constructions</option>
                    <option value="Electronics">Electronics</option>
                    <option value="Energy">Energy</option>
                    <option value="Engineering">Engineering</option>
                    <option value="Environmental">Environmental</option>
                    <option value="Government">Government</option>
                    <option value="Manufacturing">Manufacturing</option>
                    <option value="Other">Other</option>
                    <option value="Shipping">Shipping</option>
                  </Form.Select>
                  {errors4.industry && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Production /Capacity Utilisation (Unit %)"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Production /Capacity Utilisation (Unit %)"
                    name="production_capacity"
                    tabIndex="40"
                    {...register4("production_capacity", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.production_capacity && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Sector"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="sector"
                    placeholder="Sector"
                    tabIndex="35"
                    {...register4("sector", { required: false })}
                  >
                    <option value="">Select</option>
                    <option value="Government">Government</option>
                    <option value="Power Sector">Power Sector</option>
                    <option value="Private Sector">Private Sector</option>
                    <option value="Industrial">Industrial</option>
                  </Form.Select>
                  {errors4.sector && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Originiaze Import Break up (TPO/ %)	"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Originiaze Import Break up (TPO/ %)	"
                    name="originiaze_import_breakup"
                    tabIndex="41"
                    {...register4("originiaze_import_breakup", {
                      required: false,
                    })}
                  />
                  {errors4.originiaze_import_breakup && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Port"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Port"
                    name="port"
                    tabIndex="42"
                    {...register4("port", { required: false })}
                  />
                  {errors4.port && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Market impression rating"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Market impression rating"
                    name="market_impression_rating"
                    tabIndex="36"
                    {...register4("market_impression_rating", {
                      required: false,
                    })}
                  />
                  {errors4.market_impression_rating && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Origin"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Origin"
                    name="origin"
                    tabIndex="43"
                    {...register4("origin", { required: false })}
                  />
                  {errors4.origin && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

            </Row>
            {/* <Row className="mb-3">
              <h4 className="heading">Product Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 1 3800 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 1 3800 GAR"
                    name="coal_spec_1_3800_GAR"
                    {...register4("coal_spec_1_3800_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.coal_spec_1_3800_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 2 4200 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 2 4200 GAR"
                    name="coal_spec_2_4200_GAR"
                    {...register("coal_spec_2_4200_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_2_4200_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Product"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Product"
                    name="product"
                    {...register4("product", { required: false })}
                  />
                  {errors4.product && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 2 4200 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 2 4200 GAR"
                    name="coal_spec_2_4200_GAR"
                    {...register4("coal_spec_2_4200_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.coal_spec_2_4200_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingTextarea2"
                  label="Description"
                >
                  <Form.Control
                    as="textarea"
                    placeholder="Description"
                    style={{ height: "100px!important" }}
                    name="description"
                    {...register4("description", { required: false })}
                  />
                  {errors4.description && <p id="text-area">Required</p>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 3 4700 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 3 4700 GAR"
                    name="coal_spec_3_4700_GAR"
                    {...register4("coal_spec_3_4700_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.coal_spec_3_4700_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Remarks"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Remarks"
                    name="remarks"
                    {...register4("remarks", { required: false })}
                  />
                  {errors4.remarks && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 4 5000 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 4 5000 GAR"
                    name="coal_spec_4_5000_GAR"
                    {...register4("coal_spec_4_5000_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.coal_spec_4_5000_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>{" "}
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 5 5500 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 5 5500 GAR"
                    name="coal_spec_5_5500_GAR"
                    {...register4("coal_spec_5_5500_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.coal_spec_5_5500_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 6"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 6"
                    name="coal_spec_6"
                    {...register4("coal_spec_6", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.coal_spec_6 && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 7"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 7"
                    name="coal_spec_7"
                    {...register4("coal_spec_7", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.coal_spec_7 && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 8"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 8"
                    name="coal_spec_8"
                    {...register4("coal_spec_8", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.coal_spec_8 && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row> */}
            <Row>
              <h4 className="heading">Terms & Conditions</h4>
              <Form.Group as={Col} md="12">
              <label>General terms</label>
              <Editor value={generalTerms} onChange={onChangeGeneralTerm} />
              </Form.Group>

              <Form.Group as={Col} md="12">
              <label>Payment terms</label>
              <Editor value={paymentTerms} onChange={onChangePaymentTerm} />
              </Form.Group>
<br/>
            </Row>
            <Row className="mb-3">
              <h4 className="heading">System Information</h4>

        <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="account source"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="account_source"
                    placeholder="Account Source"
                    tabIndex="45"
                    {...register4("account_source", { required: false })}
                  >
                  <option value="">--None--</option><option value="Advertisement">Advertisement</option><option value="Customer Event">Customer Event</option><option value="Employee Referral">Employee Referral</option><option value="Google AdWords">Google AdWords</option><option value="Other">Other</option><option value="Partner">Partner</option><option value="Purchased List">Purchased List</option><option value="Trade Show">Trade Show</option><option value="Webinar">Webinar</option><option value="Website">Website</option><option value="Rajgopalan">Rajgopalan</option><option value="Olivia">Olivia</option>
                  {errors4.account_source && <span>Required</span>}
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>

        <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Rating"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="rating"
                    placeholder="Rating"
                    tabIndex="46"
                    {...register4("rating", { required: false })}
                  >
                   <option value="">--None--</option><option value="Hot">Hot</option><option value="Warm">Warm</option><option value="Cold">Cold</option></Form.Select>
                  {errors4.rating && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

            </Row>

            <p className='edit-cancel'><input
      type="submit"
      className="account-save"
      value={isFormsubmit ? "Saving" : "Save"}
      disabled={isFormsubmit}
    /><Link to={'/accounts/account-list'}><input type="submit" className="account-save" value="Cancel" /></Link></p>
            <div className="successDiv">
              <p></p><p></p>
            </div>
          </Form>
          </div></div></div>
        <p></p><p></p>
        <Footer />
      </>
    );
  } else if (account_record === "Employee") {
    const employees = (data) => {
      const responseData = {
        account_name: data.account_name,
        account_record_type: data.account_record_type,
        company: data.company,
        account_alias: data.account_alias,
        account_owner: data.account_owner,
        employees: data.employees,
        parent_account: data.parent_account,
        fax: data.fax,
        port: data.port,
        origin: data.origin,
        phone: data.phone,
        product: data.product,
        remarks: data.remarks,
        shipping_state_or_province: data.shipping_state_or_province,
        documents,
        billing_state_or_province: data.billing_state_or_province,
        shipping_street: shippingAddress,
        billing_street: pendingMatter,
        shipping_postal_code: data.shipping_postal_code,
        billing_postal_code: data.billing_postal_code,
        billing_city: data.billing_city,
        shipping_city: data.shipping_city,
        shipping_country: data.shipping_country,
        billing_country: data.billing_country,
      };
      console.log(JSON.stringify(responseData));
      const encryptedAccessToken = localStorage.getItem("access_token");
      const secret_key = "4d3a23fba54bbef1e14dd44ba9591612";
      if (encryptedAccessToken) {
        const decryptedAccessToken = AES.decrypt(
          encryptedAccessToken,
          secret_key
        ).toString(enc.Utf8);

        axios.post(`${API_URL}add/account`, responseData, {
          headers: {
            Authorization: `Bearer ${decryptedAccessToken}`,
            "Content-Type": "application/json",
          },
        })
          .then(response => {
            console.log(response);

            if (response.data.success === true) {
              document.getElementById('messageContainer').innerHTML = `
                  <div class="success-message">
                  ${response.data.message}
                  </div>
              `;

                window.scrollTo({
                  top: 0,
                  behavior: "smooth" // Optional: animated scrolling
              });


              navigate("/accounts/" + response.data.account_id);
          } else if (response.data.success === false) {

              document.getElementById('messageContainer').innerHTML = `
                  <div class="error-message">
                      ${response.data.message}
                  </div>
              `;

              // Scroll to the top of the page
              window.scrollTo({
                  top: 0,
                  behavior: "smooth" // Optional: animated scrolling
              });
          }
          })
          .catch(error => {
            // Handle errors
            console.error(error);
          });
      }
    };

    return (
      <>
        <Header />
        <div className="contactAccount  full-container">

         <div className="row">
       <div className="col-md-2 recent-item">
       <RecentItem/>
</div>
       <div className="col-md-10 right-section">
       <div className="page-header" id="add-account">
           <div>
             <h2 className="main-content-title tx-24 mg-b-5">Accounts </h2>
             <ol className="breadcrumb">
               <li className="breadcrumb-item active" aria-current="page">
                 Dashboard / Account/ Add Employee
               </li>
             </ol>
           </div>

         </div>
          <Form onSubmit={handleSubmit5(employees)}>
          <div id="messageContainer"></div>
          <p className='edit-cancel'><input
      type="submit"
      className="account-save"
      value={isFormsubmit ? "Saving" : "Save"}
      disabled={isFormsubmit}
    /><Link to={'/accounts/account-list'}><input type="submit" className="account-save" value="Cancel" /></Link></p>
            <Row className="mb-3">
              <h4 className="heading">Account Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Name"
                  className="mb-3"
                >
                   <Form.Control
                    type="text"
                    placeholder="Account Name"
                    name="account_name"
                    // defaultValue={account_name}
                    className="error-validation"
                    // onChange={(e) => setaccount_name(e.target.value)}
                    {...register5("account_name", { required: true })}
                    />
                    {errors5.account_name && <span>Error: You must enter a value </span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account record type"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account record type"
                    value={account_record}
                    name="account_record_type" className='record-type'
                    {...register5("account_record_type", { required: false })}
                  />
                  {errors5.account_record_type && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
               <Form.Group as={Col} md="6">

            <FloatingLabel controlId="floatingSelect"
            className='dropDown' label="Company">
  <Form.Select aria-label="Floating label select example"
  name="company"
  placeholder="Company"

  {...register5("company", { required: false })}
  >
    <option value='' >Select</option>
     {
        company.map((x)=>{
            return(
                <option value={x.company_name}>{x.company_name}</option>
            )
        })
     }
  </Form.Select>
  {errors5.company && <span>Required</span>}
</FloatingLabel>
            </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Owner"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Owner"
                    name="account_owner"
                    value={adminRole}
                    className="owner-role"
                    {...register5("account_owner", { required: false })}
                  />
                  {errors5.account_owner && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Alias"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Alias"
                    name="account_alias"
                    {...register5("account_alias", { required: false })}
                  />
                  {errors5.account_alias && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Please Enter Full Company Name here</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Parent account"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Parent account"
                    name="parent_account"
                    {...register5("parent_account", { required: false })}
                  />
                  {errors5.parent_account && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Port"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Port"
                    name="port"
                    {...register5("port", { required: false })}
                  />
                  {errors5.port && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Fax"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Fax"
                    name="fax"
                    {...register5("fax", { required: false })}
                  />
                  {errors5.fax && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Origin"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Origin"
                    name="origin"
                    {...register5("origin", { required: false })}
                  />
                  {errors5.origin && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Phone"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Phone"
                    name="phone"
                    {...register5("phone", { required: false })}
                  />
                  {errors5.phone && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Phone numbers are a great way to call people on phones. <br/> Phones are what we call our pocket computers <br/>even though we use them for games, selfies,<br/> and facebook.</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Product"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Product"
                    name="product"
                    {...register5("product", { required: false })}
                  />
                  {errors5.product && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Employees"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Employees"
                    name="employees"
                    {...register5("employees", { required: false })}
                  />
                  {errors5.employees && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Remarks"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Remarks"
                    name="remarks"
                    {...register5("remarks", { required: false })}
                  />
                  {errors5.remarks && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>
            <Row className="mb-3">
      <h4 className="heading">KYC Documents</h4>
      {documents.map((document, index) => (
        <React.Fragment key={index}>
          <Form.Group as={Col} md="6">
            <FloatingLabel
              controlId={`floatingInputName${index}`}
              label="Document Name"
              className="mb-3"
            >
              <Form.Control
                type="text"
                placeholder="Document Name"
                defaultValue={document.document_name}
                onChange={(e) => handleDocumentChange(index, 'document_name', e.target.value)}
              />
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} md="6">
            <FloatingLabel
              controlId={`floatingInputValidity${index}`}
              label="Validity"
              className="mb-3"
            >
              <Form.Control
                type="text"
                placeholder="Validity"
                defaultValue={document.validity}
                onChange={(e) => handleDocumentChange(index, 'validity', e.target.value)}
              />
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} md="1">
            {index > 0 && (
              <span id="links" onClick={() => handleRemoveDocument(index)}>
                <FaTrashAlt />
              </span>
            )}
          </Form.Group>
        </React.Fragment>
      ))}
      <span id="links" onClick={handleAddDocument}>Add Document</span>
      {/* <Button onClick={handleSubmit}>Create Account</Button> */}
    </Row>
            <Row className="mb-3">
              <h4 className="heading">Address Information</h4>
              <Form.Group as={Col} md="6" className="textarea-half b-t">
              <label>Billing Address</label>
              <Editor value={pendingMatter} onChange={onChangePending} />
              </Form.Group>
              <Form.Group as={Col} md="6" className="textarea-half b-t">
              <label>Shipping Address</label>
              <Editor value={shippingAddress} onChange={onChangeShippingAddress} />
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing postal code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing postal code"
                    name="billing_postal_code"
                    {...register5("billing_postal_code", { required: false })}
                  />
                  {errors5.billing_postal_code && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping postal code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping postal code"
                    name="shipping_postal_code"
                    {...register5("shipping_postal_code", { required: false })}
                  />
                  {errors5.shipping_postal_code && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing city"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing city"
                    name="billing_city"
                    {...register5("billing_city", { required: false })}
                  />
                  {errors5.billing_city && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping city"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping city"
                    name="shipping_city"
                    {...register5("shipping_city", { required: false })}
                  />
                  {errors5.shipping_city && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing state province"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing state province"
                    name="billing_state_or_province"
                    {...register5("billing_state_or_province", {
                      required: false,
                    })}
                  />
                  {errors5.billing_state_or_province && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping state province"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping state province"
                    name="shipping_state_or_province"
                    {...register5("shipping_state_or_province", {
                      required: false,
                    })}
                  />
                  {errors5.shipping_state_or_province && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing country"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing country"
                    name="billing_country"
                    {...register5("billing_country", { required: false })}
                  />
                  {errors5.billing_country && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping country"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing country"
                    name="shipping_country"
                    {...register5("shipping_country", { required: false })}
                  />
                  {errors5.shipping_country && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>
            <p className='edit-cancel'><input
      type="submit"
      className="account-save"
      value={isFormsubmit ? "Saving" : "Save"}
      disabled={isFormsubmit}
    /><Link to={'/accounts/account-list'}><input type="submit" className="account-save" value="Cancel" /></Link></p>
            <div className="successDiv">
              <p></p><p></p>
            </div>
          </Form>
          </div> </div> </div>
          <Footer />

      </>
    );
  } else if (account_record === "Surveyor") {
    const serviyor = (data) => {
      const responseData = {
        account_name: data.account_name,
        account_alias: data.account_alias,
        website: data.website,

        account_owner: data.account_owner,
        parent_account: data.parent_account,
        account_number: data.account_number,
        account_record_type: data.account_record_type,
        annual_revenue: parseInt(data.annual_revenue),
        description: data.description,
        no_of_employees: data.no_of_employees,
        port: data.port,
        origin: data.origin,
        remarks: data.remarks,
        product: data.product,
        general_terms: generalTerms,
        region: data.region,
        billing_street: pendingMatter,
        phone: data.phone,
        shipping_street: shippingAddress,
        billing_city: data.billing_city,
        shipping_postal_code: data.shipping_postal_code,
        shipping_city: data.shipping_city,
        shipping_state_or_province: data.shipping_state_or_province,
        shipping_country: data.shipping_country,
        billing_state_or_province: data.billing_state_or_province,
        billing_country: data.billing_country,
        fax: data.fax,
        KYC_docs: data.KYC_docs,
        KYC_doc_date: ky_date_date?ky_date_date:null,
        refrence_check_date:reference_date?reference_date:null,
        refrence_check: data.refrence_check,
        commitment: data.commitment,
        reliability: data.reliability,
        under_group: data.under_group,
        station_name: data.station_name,
        expansion_setup_or_buyer_status: data.expansion_setup_or_buyer_status,
        industry: data.industry,
        sector: data.sector,
        market_impression_rating: data.market_impression_rating,
        annual_coal_requirement_in_MT: data.annual_coal_requirement_in_MT,
        imported_volume_PA_in_MT: data.imported_volume_PA_in_MT,
        quantity_MT_monthly: data.quantity_MT_monthly,
        production_capacity: data.production_capacity,
        originiaze_import_breakup: data.originiaze_import_breakup,
        account_source: data.account_source,
        rating: data.rating,
        coal_spec_1_3800_GAR: data.coal_spec_1_3800_GAR,
        coal_spec_2_4200_GAR: data.coal_spec_2_4200_GAR,
        coal_spec_3_4700_GAR: data.coal_spec_3_4700_GAR,
        coal_spec_4_5000_GAR: data.coal_spec_4_5000_GAR,
        coal_spec_5_5500_GAR: data.coal_spec_5_5500_GAR,
        coal_spec_6: data.coal_spec_6,
        coal_spec_7: data.coal_spec_7,
        coal_spec_8: data.coal_spec_8,
        documents
      };
      console.log(JSON.stringify(responseData));
      const encryptedAccessToken = localStorage.getItem("access_token");
      const secret_key = "4d3a23fba54bbef1e14dd44ba9591612";
      if (encryptedAccessToken) {
        const decryptedAccessToken = AES.decrypt(
          encryptedAccessToken,
          secret_key
        ).toString(enc.Utf8);

        axios.post(`${API_URL}add/account`, responseData, {
          headers: {
            Authorization: `Bearer ${decryptedAccessToken}`,
            "Content-Type": "application/json",
          },
        })
          .then(response => {
            console.log(response);

            if (response.data.success === true) {
    document.getElementById('messageContainer').innerHTML = `
        <div class="success-message">
        ${response.data.message}
        </div>
    `;

      window.scrollTo({
        top: 0,
        behavior: "smooth" // Optional: animated scrolling
    });


    navigate("/accounts/" + response.data.account_id);
} else if (response.data.success === false) {

    document.getElementById('messageContainer').innerHTML = `
        <div class="error-message">
            ${response.data.message}
        </div>
    `;

    // Scroll to the top of the page
    window.scrollTo({
        top: 0,
        behavior: "smooth" // Optional: animated scrolling
    });
}
          })
          .catch(error => {
            // Handle errors
            console.error(error);
          });
      }
    };

    return (
      <>
        <Header />
        <div className="contactAccount  full-container">

          <div className="row">
        <div className="col-md-2 recent-item">
        <RecentItem/>
</div>
        <div className="col-md-10 right-section">
        <div className="page-header" id="add-account">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Accounts </h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">
                  Dashboard / Account/ Add Surveyor
                </li>
              </ol>
            </div>

          </div>
          <Form onSubmit={handleSubmit(serviyor)}>
          <div id="messageContainer"></div>
          <p className='edit-cancel'><input
      type="submit"
      className="account-save"
      value={isFormsubmit ? "Saving" : "Save"}
      disabled={isFormsubmit}
    /><Link to={'/accounts/account-list'}><input type="submit" className="account-save" value="Cancel" /></Link></p>
          <Row className="mb-3">
              <h4 className="heading">Account Information</h4>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Name"
                    className="error-validation"
                    name="account_name"
                    tabIndex={1}
                    {...register("account_name", { required: true })}
                  />
                  {errors.account_name && <span>Error: You must enter a value </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Owner"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Owner"
                    name="account_owner"
                    tabIndex={9}
                    className="owner-role"
                     value={adminRole}
                    {...register("account_owner", { required: false })}
                  />
                  {errors.account_owner && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Alias"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Alias"
                    name="account_alias"
                    tabIndex={2}
                    {...register("account_alias", { required: false })}
                  />
                  {errors.account_alias && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Please Enter Full Company Name here</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Number"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Account Number"
                    name="account_number"
                    tabIndex={10}
                    {...register("account_number", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.website && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Website"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Website"
                    name="website"
                    tabIndex={3}
                    {...register("website", { required: false })}
                  />
                  {errors.website && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account record type"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account record type"
                    value={account_record}
                    tabIndex={11}
                    name="account_record_type" className='record-type'
                    {...register("account_record_type", { required: false })}
                  />
                  {errors.account_record_type && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Trader"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Trader"
                    name="trader"
                    tabIndex={4}
                    {...register("trader", { required: false })}
                  />
                  {errors.trader && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Trader</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
                 
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Annual Revenue"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Annual Revenue"
                    tabIndex={12}
                    name="annual_revenue"
                    {...register("annual_revenue", { valueAsNumber:true,required: false })}
                  />
                  {errors4.annual_revenue && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>


              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Port"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Port"
                    name="port"
                    tabIndex={5}
                    {...register("port", { required: false })}
                  />
                  {errors.port && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

               <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="No of employees"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="No of employees"
                    name="no_of_employees"
                    tabIndex={13}
                    {...register("no_of_employees", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors4.no_of_employees && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              {/* <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Annual revenue"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Annual revenue"
                    name="annual_revenue"
                    {...register("annual_revenue", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.annual_revenue && <span>Required</span>}
                </FloatingLabel>
              </Form.Group> */}

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Origin"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={6}
                    placeholder="Origin"
                    name="origin"
                    {...register("origin", { required: false })}
                  />
                  {errors.origin && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              {/* <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="No of employees"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="No of employees"
                    name="no_of_employees"
                    {...register("no_of_employees", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.no_of_employees && <span>Required</span>}
                </FloatingLabel>
              </Form.Group> */}

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Product"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={7}
                    placeholder="Product"
                    name="product"
                    {...register("product", { required: false })}
                  />
                  {errors.product && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Remarks"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Remarks"
                    name="remarks"
                    tabIndex={8}
                    {...register("remarks", { required: false })}
                  />
                  {errors.remarks && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
            </Row>
            <Row className="mb-3">
              <h4 className="heading">Address Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Region"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Region"
                    name="region"
                    tabIndex={14}
                    {...register("region", { required: false })}
                  />
                  {errors.region && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Phone"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Phone"
                    tabIndex={20}
                    name="phone"
                    {...register("phone", { required: false })}
                  />
                  {errors.phone && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Phone numbers are a great way to call people on phones. <br/> Phones are what we call our pocket computers <br/>even though we use them for games, selfies,<br/> and facebook.</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>

              <Form.Group as={Col} md="6" className="textarea-half b-t">
              <label>Billing Address</label>
              <Editor value={pendingMatter} onChange={onChangePending} tabIndex={15}/>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Fax"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="fax"
                    name="fax"
                    tabIndex={21}
                    {...register("fax", { required: false })}
                  />
                  {errors.fax && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing postal code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing postal code"
                    name="billing_postal_code"
                    tabIndex={16}
                    {...register("billing_postal_code", { required: false })}
                  />
                  {errors.billing_postal_code && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6" className="textarea-half b-t">
              <label>Shipping Address</label>
              <Editor value={shippingAddress} onChange={onChangeShippingAddress} tabIndex={21}/>
              </Form.Group>


              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing city"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing city"
                    name="billing_city"
                    tabIndex={17}
                    {...register("billing_city", { required: false })}
                  />
                  {errors.billing_city && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping postal code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={22}
                    placeholder="Shipping postal code"
                    name="shipping_postal_code"
                    {...register("shipping_postal_code", { required: false })}
                  />
                  {errors.shipping_postal_code && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing state province"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing state province"
                    tabIndex={18}
                    name="billing_state_or_province"
                    {...register("billing_state_or_province", {
                      required: false,
                    })}
                  />
                  {errors.billing_state_or_province && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping city"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping city"
                    tabIndex={23}
                    name="shipping_city"
                    {...register("shipping_city", { required: false })}
                  />
                  {errors.shipping_city && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing country"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing country"
                    tabIndex={19}
                    name="billing_country"
                    {...register("billing_country", { required: false })}
                  />
                  {errors.billing_country && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>


              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping state province"
                  
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={24}
                    placeholder="Shipping state province"
                    name="shipping_state_or_province"
                    {...register("shipping_state_or_province", {
                      required: false,
                    })}
                  />
                  {errors.shipping_state_or_province && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>


              <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping country"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={25}
                    placeholder="shipping country"
                    name="shipping_country"
                    {...register("shipping_country", { required: false })}
                  />
                  {errors.shipping_country && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <h4 className="heading">KYC Documents</h4>
               {documents.map((document, index) => (
        <>

          <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Document Name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Document Name"
                    tabIndex={26}
                    defaultValue={document.name}
                    onChange={(e) => handleDocumentChange(index, 'document_name', e.target.value)}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Validity"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={27}
                    placeholder="Validity"
                    defaultValue={document.validity}
                    onChange={(e) => handleDocumentChange(index, 'validity', e.target.value)}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="1">
          {index > 0 && (
            <span id="links" onClick={() => handleRemoveDocument(index)}><FaTrashAlt/></span>
          )}
          </Form.Group>
        </>
      ))}
      <span id="links" onClick={handleAddDocument}>Add Document</span>
      {/* <button onClick={handleSubmit}>Create Account</button> */}
              </Row>
              <Row className="mb-3">
              <h4 className="heading">Rwood Reference</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="KYC docs"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="KYC docs"
                    tabIndex={28}
                    name="KYC_docs"
                    {...register("KYC_docs", { required: false })}
                  />
                  {errors.KYC_docs && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Commitment"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="commitment"
                    tabIndex={32}            
                    placeholder="Commitment"
                    defaultValue=""
                    {...register("commitment", { required: false })}
                  >
                    <option value="">Select</option>
                    <option value="Minimum Term">Minimum Term</option>
                    <option value="Short Term">Short Term</option>
                    <option value="Long Term">Long Term</option>
                  </Form.Select>
                  {errors.commitment && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
        <FloatingLabel
          controlId="floatingInput"
          label="KYC Doc date"
          className="mb-3 datepick"


        >
           <DatePicker
        selected={kycdoc}
        onChange={handleStartDateKyc}
        tabIndex={29}
        dateFormat='dd/MM/yyyy'
        startDate={kycdoc} placeholderText="Select"
      />
        </FloatingLabel>
      </Form.Group>
      <Form.Group as={Col} md="6"  className="textarea-half">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Reliability"
                  className="mb-3"
                >
                  <Form.Control
                    as="textarea"
                    tabIndex={33}
                    placeholder="Reliability"
                    name="reliability"
                    {...register("reliability", { required: false })}
                  />
                  {errors.reliability && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Refrence check"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Refrence check"
                    tabIndex={30}
                    name="refrence_check"
                    {...register("refrence_check", { required: false })}
                  />
                  {errors.refrence_check && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>

<Form.Group as={Col} md="6">
       <FloatingLabel
          controlId="floatingInput"
          label="Refrence Check Date"
          className="mb-3 datepick"


        >
           <DatePicker
        selected={startDate}
        onChange={handleStartDateChange}
        selectsStart
        tabIndex={31}
        dateFormat='dd/MM/yyyy'
        startDate={startDate} placeholderText="Select"
      />
        </FloatingLabel>
      </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
            </Row>
            {/* <Row className="mb-3">
              <h4 className="heading">Product Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 1 3800 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 1 3800 GAR"
                    name="coal_spec_1_3800_GAR"
                    {...register("coal_spec_1_3800_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_1_3800_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 3 4700 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 3 4700 GAR"
                    name="coal_spec_3_4700_GAR"
                    {...register("coal_spec_3_4700_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_3_4700_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 2 4200 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 2 4200 GAR"
                    name="coal_spec_2_4200_GAR"
                    {...register("coal_spec_2_4200_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_2_4200_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 4 5000 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 4 5000 GAR"
                    name="coal_spec_4_5000_GAR"
                    {...register("coal_spec_4_5000_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_4_5000_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>{" "}
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 5 5500 GAR"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 5 5500 GAR"
                    name="coal_spec_5_5500_GAR"
                    {...register("coal_spec_5_5500_GAR", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_5_5500_GAR && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 6"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 6"
                    name="coal_spec_6"
                    {...register("coal_spec_6", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_6 && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 7"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 7"
                    name="coal_spec_7"
                    {...register("coal_spec_7", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_7 && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Coal specification 8"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Coal specification 8"
                    name="coal_spec_8"
                    {...register("coal_spec_8", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.coal_spec_8 && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="12">
                <FloatingLabel
                  controlId="floatingTextarea2"
                  label="Description"
                >
                  <Form.Control
                    as="textarea"
                    placeholder="Description"
                    style={{ height: "100px" }}
                    name="description"
                    {...register("description", { required: false })}
                  />
                  {errors.description && <p id="text-area">Required</p>}
                </FloatingLabel>
              </Form.Group>
            </Row> */}
                <Row className="mb-3">
              <h4 className="heading">Industry Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Parent account"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Parent account"
                    name="parent_account"
                    tabIndex={34}
                    {...register("parent_account", { required: false })}
                  />
                  {errors.parent_account && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" className='tooltips'>
                <FloatingLabel
                  controlId="floatingInput"
                  label="annual coal requirement in  MT"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="annual coal requirement in  MT"
                    name="annual_coal_requirement_in_MT"
                    {...register("annual_coal_requirement_in_MT", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.annual_coal_requirement_in_MT && (
                    <span>Required</span>
                  )}
                </FloatingLabel>
                <Tooltip text={<span>in MT</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Under group"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Under group"
                    tabIndex={35}
                    name="under_group"
                    {...register("under_group", { required: false })}
                  />
                  {errors.under_group && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Imported volume PA in MT"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Imported volume PA in MT"
                    name="imported_volume_PA_in_MT"
                    tabIndex={41}
                    {...register("imported_volume_PA_in_MT", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.imported_volume_PA_in_MT && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>{" "}
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Station name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Station name"
                    name="station_name"
                    tabIndex={36}
                    {...register("station_name", { required: false })}
                  />
                  {errors.station_name && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>{" "}
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Quantity MT monthly"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Quantity MT monthly"
                    tabIndex={42}
                    name="quantity_MT_monthly"
                    {...register("quantity_MT_monthly", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.quantity_MT_monthly && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Expansion setup or buyer status"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="expansion_setup_or_buyer_status"
                    placeholder="Expansion setup or buyer status"
                    tabIndex={37}
                    defaultValue=""
                    {...register("expansion_setup_or_buyer_status", {
                      required: false,
                    })}
                  >
                    <option value="">Select</option>
                    <option value="Under Construction">
                      Under Construction
                    </option>
                    <option value="Operated">Operated</option>
                    <option value="Permitted">Permitted</option>
                  </Form.Select>
                  {errors.expansion_setup_or_buyer_status && (
                    <span>Required </span>
                  )}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Production capacity"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Production capacity"
                    tabIndex={43}
                    name="production_capacity"
                    {...register("production_capacity", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.production_capacity && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
<Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Originiaze Import Break up (TPO/ %)	"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Originiaze Import Break up (TPO/ %)	"
                    name="originiaze_import_breakup"
                    tabIndex={44}
                    {...register("originiaze_import_breakup", {
                      required: false,
                    })}
                  />
                  {errors.originiaze_import_breakup && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
                            <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Industry"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="industry"
                    placeholder="Industry"
                    className="m-b"
                    tabIndex={38}
                    {...register("industry", { required: false })}
                  >
                    <option value="">Select</option>
                    <option value="Chemicals">Chemicals</option>
                    <option value="Constructions">Constructions</option>
                    <option value="Electronics">Electronics</option>
                    <option value="Energy">Energy</option>
                    <option value="Engineering">Engineering</option>
                    <option value="Environmental">Environmental</option>
                    <option value="Government">Government</option>
                    <option value="Manufacturing">Manufacturing</option>
                    <option value="Other">Other</option>
                    <option value="Shipping">Shipping</option>
                  </Form.Select>
                  {errors.industry && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              {/* <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Originiaze Import Break up (TPO/ %)	"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Originiaze Import Break up (TPO/ %)	"
                    name="originiaze_import_breakup"
                    {...register("originiaze_import_breakup", {
                      required: false,
                    })}
                  />
                  {errors.originiaze_import_breakup && <span>Required</span>}
                </FloatingLabel>
              </Form.Group> */}
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Sector"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="sector"
                    placeholder="Sector"
                    className="m-b"
                    tabIndex={39}
                    {...register("sector", { required: false })}
                  >
                    <option value="">Select</option>
                    <option value="Government">Government</option>
                    <option value="Power Sector">Power Sector</option>
                    <option value="Private Sector">Private Sector</option>
                    <option value="Industrial">Industrial</option>
                  </Form.Select>
                  {errors.sector && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Market impression rating"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    className="m-b"
                    placeholder="Market impression rating"
                    name="market_impression_rating"
                    tabIndex={40}
                    {...register("market_impression_rating", {
                      required: false,
                    })}
                  />
                  {errors.market_impression_rating && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <h4 className="heading">Account Summary</h4>

        <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="account source"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="account_source"
                    tabIndex={45}
                    placeholder="account source"
                    defaultValue=""
                    {...register("account_source", { required: false })}
                  >
                  <option value="">--None--</option><option value="Advertisement">Advertisement</option><option value="Customer Event">Customer Event</option><option value="Employee Referral">Employee Referral</option><option value="Google AdWords">Google AdWords</option><option value="Other">Other</option><option value="Partner">Partner</option><option value="Purchased List">Purchased List</option><option value="Trade Show">Trade Show</option><option value="Webinar">Webinar</option><option value="Website">Website</option><option value="Rajgopalan">Rajgopalan</option><option value="Olivia">Olivia</option>
                  {errors.account_source && <span>Required</span>}
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>

    <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Rating"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="rating"
                    placeholder="Rating"
                    tabIndex={46}
                    {...register("rating", { required: false })}
                  >
                   <option value="">--None--</option><option value="Hot">Hot</option><option value="Warm">Warm</option><option value="Cold">Cold</option></Form.Select>
                  {errors.rating && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <h4 className="heading">System Information</h4>

              <Form.Group as={Col} md="12">
              <label>General terms</label>
              <Editor value={generalTerms} onChange={onChangeGeneralTerm} tabIndex={47}/>
              </Form.Group>
            </Row>

            <p className='edit-cancel'><input
      type="submit"
      className="account-save"
      value={isFormsubmit ? "Saving" : "Save"}
      disabled={isFormsubmit}
    /><Link to={'/accounts/account-list'}><input type="submit" className="account-save" value="Cancel" /></Link></p>
            <div className="successDiv">
              <p></p><p></p>
            </div>
          </Form>
          </div>  </div>  </div>
        <Footer />
      </>
    );
  } else if (account_record === "Competitor") {
    const onSubmit = (data) => {
      setFormsubmited(true)
      const responseData = {
        account_name: data.account_name,
        account_alias: data.account_alias,
        website: data.website,
        account_owner: data.account_owner,
        parent_account: data.parent_account,
        account_number: data.account_number,
        account_record_type: data.account_record_type,
        annual_revenue: parseInt(data.annual_revenue),
        description: data.description,
        no_of_employees: data.no_of_employees,
        general_terms: generalTerms,
        region: data.region,
        billing_street: pendingMatter,
        phone: data.phone,
        shipping_street: shippingAddress,
        billing_city: data.billing_city,
        shipping_postal_code: data.shipping_postal_code,
        shipping_city: data.shipping_city,
        shipping_state_or_province: data.shipping_state_or_province,
        shipping_country: data.shipping_country,
        billing_state_or_province: data.billing_state_or_province,
        billing_country: data.billing_country,
        fax: data.fax,
        KYC_docs: data.KYC_docs,
        KYC_doc_date: ky_date_date?ky_date_date:null,
        refrence_check_date:reference_date?reference_date:null,
        refrence_check: data.refrence_check,
        commitment: data.commitment,
        reliability: data.reliability,
        under_group: data.under_group,
        port: data.port,
        origin: data.origin,
        imported_volume_from_indonesia_PA_in_MT:parseInt(
          data.imported_volume_from_indonesia_PA_in_MT),
        payment_terms: paymentTerms,
        station_name: data.station_name,
        expansion_setup_or_buyer_status: data.expansion_setup_or_buyer_status,
        industry: data.industry,
        sector: data.sector,
        market_impression_rating: data.market_impression_rating,
        annual_coal_requirement_in_MT: data.annual_coal_requirement_in_MT,
        imported_volume_PA_in_MT: data.imported_volume_PA_in_MT,
        quantity_MT_monthly: data.quantity_MT_monthly,
        production_capacity: data.production_capacity,
        originiaze_import_breakup: data.originiaze_import_breakup,
        account_source: data.account_source,
        rating: data.rating,
        coal_spec_1_3800_GAR: data.coal_spec_1_3800_GAR,
        coal_spec_2_4200_GAR: data.coal_spec_2_4200_GAR,
        coal_spec_3_4700_GAR: data.coal_spec_3_4700_GAR,
        coal_spec_4_5000_GAR: data.coal_spec_4_5000_GAR,
        coal_spec_5_5500_GAR: data.coal_spec_5_5500_GAR,
        coal_spec_6: data.coal_spec_6,
        coal_spec_7: data.coal_spec_7,
        coal_spec_8: data.coal_spec_8,
        documents
      };
      console.log(JSON.stringify(responseData));
      const encryptedAccessToken = localStorage.getItem("access_token");
      const secret_key = "4d3a23fba54bbef1e14dd44ba9591612";
      if (encryptedAccessToken) {
        const decryptedAccessToken = AES.decrypt(
          encryptedAccessToken,
          secret_key
        ).toString(enc.Utf8);

        axios.post(`${API_URL}add/account`, responseData, {
          headers: {
            Authorization: `Bearer ${decryptedAccessToken}`,
            "Content-Type": "application/json",
          },
        })
          .then(response => {
            console.log(response);

            if (response.data.success === true) {
    document.getElementById('messageContainer').innerHTML = `
        <div class="success-message">
        ${response.data.message}
        </div>
    `;

      window.scrollTo({
        top: 0,
        behavior: "smooth" // Optional: animated scrolling
    });


    navigate("/accounts/" + response.data.account_id);
} else if (response.data.success === false) {

    document.getElementById('messageContainer').innerHTML = `
        <div class="error-message">
            ${response.data.message}
        </div>
    `;

    // Scroll to the top of the page
    window.scrollTo({
        top: 0,
        behavior: "smooth" // Optional: animated scrolling
    });
}
          })
          .catch(error => {
            // Handle errors
            console.error(error);
          });
      }
    };

    return (
      <>
        <Header />
        <div className="contactAccount  full-container">

         <div className="row">
       <div className="col-md-2 recent-item">
       <RecentItem/>
</div>
       <div className="col-md-10 right-section">
       <div className="page-header" id="add-account">
           <div>
             <h2 className="main-content-title tx-24 mg-b-5">Accounts </h2>
             <ol className="breadcrumb">
               <li className="breadcrumb-item active" aria-current="page">
                 Dashboard / Account/ Add Competitor
               </li>
             </ol>
           </div>

         </div>
               <Form onSubmit={handleSubmit(onSubmit)}>
               <div id="messageContainer"></div>
          <p className='edit-cancel'><input
      type="submit"
      className="account-save"
      value={isFormsubmit ? "Saving" : "Save"}
      disabled={isFormsubmit}
    /><Link to={'/accounts/account-list'}><input type="submit" className="account-save" value="Cancel" /></Link></p>
            <Row className="mb-3">
              <h4 className="heading">Account Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Name"
                  className="mb-3"
                >
                   <Form.Control
                    type="text"
                    placeholder="Account Name"
                    name="account_name"
                    tabIndex={1}
                    // defaultValue={account_name}
                    className="error-validation"
                    // onChange={(e) => setaccount_name(e.target.value)}
                    {...register("account_name", { required: true })}
                    />
                    {errors.account_name && <span>Error: You must enter a value </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Owner"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Owner"
                    name="account_owner"
                    tabIndex={5}
                    value={adminRole}
                    className="owner-role"
                    {...register("account_owner", { required: false })}
                  />
                  {errors.account_owner && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Alias"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Alias"
                    tabIndex={2}
                    name="account_alias"
                    {...register("account_alias", { required: false })}
                  />
                  {errors.account_alias && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Please Enter Full Company Name here</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Parent Account"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Parent Account"
                    name="parent_account"
                    tabIndex={6}
                    {...register("parent_account", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.parent_account && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Website"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Website"
                    tabIndex={3}
                    name="website"
                    {...register("website", { required: false })}
                  />
                  {errors.website && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account Number"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    tabIndex={7}
                    placeholder="Account Number"
                    name="account_number"
                    {...register("account_number", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.account_number && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Trader"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Trader"
                    name="trader"
                    tabIndex={4}
                    {...register("trader", { required: false })}
                  />
                  {errors.trader && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Trader</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
            
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Account record type"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={8}
                    placeholder="Account record type"
                    value={account_record}
                    name="account_record_type" className='record-type'
                    {...register("account_record_type", { required: false })}
                  />
                  {errors.account_record_type && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
{/*
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Annual revenue"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Annual revenue"
                    name="annual_revenue"
                    {...register("annual_revenue", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.annual_revenue && <span>Required</span>}
                </FloatingLabel>
              </Form.Group> */}

              {/* <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="No of employees"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="No of employees"
                    name="no_of_employees"
                    {...register("no_of_employees", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.no_of_employees && <span>Required</span>}
                </FloatingLabel>
              </Form.Group> */}

              <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Annual Revenue"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={9}
                    placeholder="Annual Revenue"
                    name="annual_revenue"
                    {...register("annual_revenue", { required: false })}
                  />
                  {errors.annual_revenue && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
               <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="No of employees"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="No of employees"
                    name="no_of_employees"
                    tabIndex={10}
                    {...register("no_of_employees", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.no_of_employees && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <h4 className="heading">Address Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Region"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Region"
                    tabIndex={11}
                    name="region"
                    {...register("region", { required: false })}
                  />
                  {errors.region && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>

              <Form.Group as={Col} md="6" className="textarea-half b-t">
              <label>Billing Address</label>
              <Editor value={pendingMatter} onChange={onChangePending} tabIndex={12} />
              </Form.Group><br/>
              <Form.Group as={Col} md="6" className="textarea-half b-t">
              <label>Shipping Address</label>
              <Editor value={shippingAddress} onChange={onChangeShippingAddress} tabIndex={18}/>
              </Form.Group><br/>


<Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing postal code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing postal code"
                    name="billing_postal_code"
                    tabIndex={13}
                    {...register("billing_postal_code", { required: false })}
                  />
                  {errors.billing_postal_code && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing city"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing city"
                    name="billing_city"
                    tabIndex={19}
                    {...register("billing_city", { required: false })}
                  />
                  {errors.billing_city && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping postal code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping postal code"
                    name="shipping_postal_code"
                    tabIndex={14}
                    {...register("shipping_postal_code", { required: false })}
                  />
                  {errors.shipping_postal_code && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing state province"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing state province"
                    name="billing_state_or_province"
                    tabIndex={20}
                    {...register("billing_state_or_province", {
                      required: false,
                    })}
                  />
                  {errors.billing_state_or_province && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping state province"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={15}
                    placeholder="Shipping state province"
                    name="shipping_state_or_province"
                    {...register("shipping_state_or_province", {
                      required: false,
                    })}
                  />
                  {errors.shipping_state_or_province && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping city"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping city"
                    name="shipping_city"
                    tabIndex={21}
                    {...register("shipping_city", { required: false })}
                  />
                  {errors.shipping_city && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Billing country"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Billing country"
                    name="billing_country"
                    tabIndex={16}
                    {...register("billing_country", { required: false })}
                  />
                  {errors.billing_country && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Shipping country"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Shipping country"
                    tabIndex={22}
                    name="shipping_country"
                    {...register("shipping_country", { required: false })}
                  />
                  {errors.shipping_country && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Phone"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Phone"
                    name="phone"
                    tabIndex={17}
                    {...register("phone", { required: false })}
                  />
                  {errors.phone && <span>Required</span>}
                </FloatingLabel>
                <Tooltip text={<span>Phone numbers are a great way to call people on phones. <br/> Phones are what we call our pocket computers <br/>even though we use them for games, selfies,<br/> and facebook.</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Fax"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="fax"
                    name="fax"
                    tabIndex={29}
                    {...register("fax", { required: false })}
                  />
                  {errors.fax && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <h4 className="heading">KYC Documents</h4>
               {documents.map((document, index) => (
        <>

          <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Document Name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={30}
                    placeholder="Document Name"
                    defaultValue={document.name}
                    onChange={(e) => handleDocumentChange(index, 'document_name', e.target.value)}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Validity"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    tabIndex={31}
                    placeholder="Validity"
                    defaultValue={document.validity}
                    onChange={(e) => handleDocumentChange(index, 'validity', e.target.value)}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="1">
          {index > 0 && (
            <span id="links" onClick={() => handleRemoveDocument(index)}><FaTrashAlt/></span>
          )}
          </Form.Group>
        </>
      ))}
      <span id="links" onClick={handleAddDocument}>Add Document</span>
      {/* <button onClick={handleSubmit}>Create Account</button> */}
              </Row>
              <Row className="mb-3">
              <h4 className="heading">Rwood Reference</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="KYC docs"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="KYC docs"
                    tabIndex={32}
                    name="KYC_docs"
                    {...register("KYC_docs", { required: false })}
                  />
                  {errors.KYC_docs && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Commitment"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="commitment"
                    placeholder="Commitment"
                    tabIndex={35}
                    {...register("commitment", { required: false })}
                  >
                    <option value="">Select</option>
                    <option value="Minimum Term">Minimum Term</option>
                    <option value="Short Term">Short Term</option>
                    <option value="Long Term">Long Term</option>
                  </Form.Select>
                  {errors.commitment && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
        <FloatingLabel
          controlId="floatingInput"
          label="KYC Doc date"
          className="mb-3 datepick"


        >
           <DatePicker
        selected={kycdoc}
        tabIndex={33}
        onChange={handleStartDateKyc}
        dateFormat='dd/MM/yyyy'
        startDate={kycdoc} placeholderText="Select"
      />
        </FloatingLabel>
      </Form.Group>
      <Form.Group as={Col} md="6"  className="textarea-half">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Reliability"
                  className="mb-3"
                >
                  <Form.Control
                    as="textarea"
                    tabIndex={36}
                    placeholder="Reliability"
                    name="reliability"
                    {...register("reliability", { required: false })}
                  />
                  {errors.reliability && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Refrence check"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Refrence check"
                    tabIndex={34}
                    name="refrence_check"
                    {...register("refrence_check", { required: false })}
                  />
                  {errors.refrence_check && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>

<Form.Group as={Col} md="6">
       <FloatingLabel
          controlId="floatingInput"
          label="Refrence Check Date"
          className="mb-3 datepick"


        >
           <DatePicker
        selected={startDate}
        onChange={handleStartDateChange}
        selectsStart
        tabIndex={34}
        dateFormat='dd/MM/yyyy'
        startDate={startDate} placeholderText="Select"
      />
        </FloatingLabel>
      </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
            </Row>
            <Row className="mb-3">
              <h4 className="heading">Industry Information</h4>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Under group"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Under group"
                    name="under_group"
                    tabIndex={37}
                    {...register("under_group", { required: false })}
                  />
                  {errors.under_group && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6" className="tooltips">
                <FloatingLabel
                  controlId="floatingInput"
                  label="annual coal requirement in  MT"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="annual coal requirement in  MT"
                    name="annual_coal_requirement_in_MT"
                    tabIndex={43}
                    {...register("annual_coal_requirement_in_MT", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.annual_coal_requirement_in_MT && (
                    <span>Required</span>
                  )}
                </FloatingLabel>
                <Tooltip text={<span>in MT</span>} placement="left">
      <IoIosHelpCircle id="help" />
      </Tooltip>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Station name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Station name"
                    tabIndex={38}
                    name="station_name"
                    {...register("station_name", { required: false })}
                  />
                  {errors.station_name && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Imported volume PA in MT"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Imported volume PA in MT"
                    tabIndex={44}
                    name="imported_volume_PA_in_MT"
                    {...register("imported_volume_PA_in_MT", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.imported_volume_PA_in_MT && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Expansion setup or buyer status"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    tabIndex={39}
                    name="expansion_setup_or_buyer_status"
                    placeholder="Expansion setup or buyer status"
                    defaultValue=""
                    {...register("expansion_setup_or_buyer_status", {
                      required: false,
                    })}
                  >
                    <option value="">Select</option>
                    <option value="Under Construction">
                      Under Construction
                    </option>
                    <option value="Operated">Operated</option>
                    <option value="Permitted">Permitted</option>
                  </Form.Select>
                  {errors.expansion_setup_or_buyer_status && (
                    <span>Required</span>
                  )}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Imported volume from indonesia PA in MT"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Imported volume from indonesia PA in MT"
                    name="imported_volume_from_indonesia_PA_in_MT"
                    tabIndex={45}
                    {...register("imported_volume_from_indonesia_PA_in_MT", {
                      required: false,
                    })}
                  />
                  {errors.imported_volume_from_indonesia_PA_in_MT && (
                    <span>Required</span>
                  )}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Quantity MT monthly"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Quantity MT monthly"
                    name="quantity_MT_monthly"
                    tabIndex={46}
                    {...register("quantity_MT_monthly", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.quantity_MT_monthly && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Industry"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="industry"
                    tabIndex={40}
                    placeholder="Industry"
                    defaultValue=""
                    {...register("industry", { required: false })}
                  >
                    <option value="">Select</option>
                    <option value="Chemicals">Chemicals</option>
                    <option value="Constructions">Constructions</option>
                    <option value="Electronics">Electronics</option>
                    <option value="Energy">Energy</option>
                    <option value="Engineering">Engineering</option>
                    <option value="Environmental">Environmental</option>
                    <option value="Government">Government</option>
                    <option value="Manufacturing">Manufacturing</option>
                    <option value="Other">Other</option>
                    <option value="Shipping">Shipping</option>
                  </Form.Select>
                  {errors.industry && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Production /Capacity Utilisation (Unit %)"
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    placeholder="Production /Capacity Utilisation (Unit %)"
                    name="production_capacity"
                    tabIndex={47}
                    {...register("production_capacity", {
                      valueAsNumber: true,
                      required: false,
                    })}
                  />
                  {errors.production_capacity && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>


              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Sector"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="sector"
                    placeholder="Sector"
                    tabIndex={41}
                    {...register("sector", { required: false })}
                  >
                    <option value="">Select</option>
                    <option value="Government">Government</option>
                    <option value="Power Sector">Power Sector</option>
                    <option value="Private Sector">Private Sector</option>
                    <option value="Industrial">Industrial</option>
                  </Form.Select>
                  {errors.sector && <span>Required </span>}
                </FloatingLabel>
              </Form.Group>{" "}
             <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Originiaze Import Break up (TPO/ %)	"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Originiaze Import Break up (TPO/ %)	"
                    name="originiaze_import_breakup"
                    tabIndex={48}
                    {...register("originiaze_import_breakup", {
                      required: false,
                    })}
                  />
                  {errors.originiaze_import_breakup && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6"></Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Port"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Port"
                    name="port"
                    tabIndex={49}
                    {...register("port", { required: false })}
                  />
                  {errors.port && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Market impression rating"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Market impression rating"
                    name="market_impression_rating"
                    tabIndex={42}
                    {...register("market_impression_rating", {
                      required: false,
                    })}
                  />
                  {errors.market_impression_rating && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Origin"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Origin"
                    name="origin"
                    tabIndex={50}
                    
                    {...register("origin", { required: false })}
                  />
                  {errors.origin && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <h4 className="heading">Terms and Conditions</h4>

              <Form.Group as={Col} md="12">
              <label>General terms</label>
              <Editor value={generalTerms} onChange={onChangeGeneralTerm} tabIndex={51}/>
              </Form.Group>
              <Form.Group as={Col} md="12">
              <label>Payment terms</label>
              <Editor value={paymentTerms} onChange={onChangePaymentTerm} tabIndex={52}/>
              </Form.Group>
               <br/>
            </Row>

            <Row className="mb-3">
              <h4 className="heading">System Information</h4>

        <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="account source"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="account_source"
                    placeholder="account source"
                    tabIndex={53}
                    {...register("account_source", { required: false })}
                  >
                  <option value="">--None--</option><option value="Advertisement">Advertisement</option><option value="Customer Event">Customer Event</option><option value="Employee Referral">Employee Referral</option><option value="Google AdWords">Google AdWords</option><option value="Other">Other</option><option value="Partner">Partner</option><option value="Purchased List">Purchased List</option><option value="Trade Show">Trade Show</option><option value="Webinar">Webinar</option><option value="Website">Website</option><option value="Rajgopalan">Rajgopalan</option><option value="Olivia">Olivia</option>
                  {errors.account_source && <span>Required</span>}
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>

        <Form.Group as={Col} md="6">
                <FloatingLabel
                  controlId="floatingSelect"
                  className="dropDown"
                  label="Rating"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    name="rating"
                    placeholder="Rating"
                    tabIndex={54}
                    defaultValue=""
                    {...register("rating", { required: false })}
                  >
                   <option value="">--None--</option><option value="Hot">Hot</option><option value="Warm">Warm</option><option value="Cold">Cold</option></Form.Select>
                  {errors.rating && <span>Required</span>}
                </FloatingLabel>
              </Form.Group>
            </Row>

            <p className='edit-cancel'><input
      type="submit"
      className="account-save"
      value={isFormsubmit ? "Saving" : "Save"}
      disabled={isFormsubmit}
    /><Link to={'/accounts/account-list'}><input type="submit" className="account-save" value="Cancel" /></Link></p>
            <div className="successDiv">
              <p></p><p></p>
            </div>
          </Form>
          </div> </div> </div>
        <Footer />
      </>
    );

  }
};

export default NewAccounts;
